{
  "app": {
    "name": "HMS",
    "fullName": "Hospital Management System",
    "tagline": "Care, coordinated."
  },
  "common": {
    "save": "Save",
    "saving": "Saving…",
    "cancel": "Cancel",
    "close": "Close",
    "edit": "Edit",
    "delete": "Delete",
    "add": "Add",
    "create": "Create",
    "search": "Search",
    "searchPlaceholder": "Search…",
    "loading": "Loading…",
    "retry": "Retry",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "actions": "Actions",
    "status": "Status",
    "details": "Details",
    "none": "None",
    "all": "All",
    "optional": "Optional",
    "required": "Required",
    "notes": "Notes",
    "reason": "Reason",
    "date": "Date",
    "time": "Time",
    "from": "From",
    "to": "To",
    "filter": "Filter",
    "clear": "Clear",
    "refresh": "Refresh",
    "print": "Print",
    "export": "Export",
    "import": "Import",
    "reset": "Reset",
    "view": "View",
    "open": "Open",
    "submit": "Submit",
    "select": "Select",
    "selectPlaceholder": "Select…",
    "noResults": "No results found",
    "total": "Total",
    "showing": "{{from}}–{{to}} of {{total}}",
    "unknown": "Unknown",
    "saved": "Saved",
    "today": "Today",
    "name": "Name",
    "code": "Code",
    "type": "Type",
    "description": "Description",
    "createdAt": "Created",
    "updatedAt": "Updated",
    "yearsShort": "{{count}} y",
    "dash": "—",
    "more": "More",
    "active": "Active",
    "inactive": "Inactive",
    "first": "First page",
    "last": "Last page",
    "pageOf": "Page {{page}} of {{pages}}",
    "rowsPerPage": "Rows per page",
    "pagination": "Pagination",
    "viewAs": "View as",
    "views": {
      "list": "List",
      "cards": "Cards",
      "grid": "Grid"
    },
    "datePlaceholder": "dd/mm/yyyy",
    "pickDate": "Pick a date",
    "change": "Change",
    "goToPage": "Go to page",
    "jumpBack": "Back {{count}} pages",
    "jumpForward": "Forward {{count}} pages",
    "cancelled": "Cancelled",
    "choose": "Choose…",
    "selectAll": "Select all"
  },
  "nav": {
    "dashboard": "Dashboard",
    "patients": "Patients",
    "appointments": "Appointments",
    "queue": "Queue",
    "encounters": "Encounters",
    "pharmacy": "Pharmacy",
    "laboratory": "Laboratory",
    "billing": "Billing",
    "administration": "Administration",
    "users": "Users",
    "departments": "Departments",
    "practitioners": "Practitioners",
    "hospital": "Hospital",
    "auditLog": "Audit log",
    "translations": "Translations",
    "languages": "Languages",
    "settings": "Settings",
    "notifications": "Notifications",
    "signOut": "Sign out",
    "menu": "Menu",
    "home": "Home",
    "eyeCenter": "Eye Center",
    "treatmentCycles": "Treatment cycles",
    "patientApp": "Patient app",
    "reports": "Reports",
    "locations": "Locations",
    "inventory": "Inventory",
    "inpatient": "Inpatient",
    "bedBoard": "Bed board",
    "admissions": "Admissions",
    "wardSetup": "Wards, rooms & beds",
    "specialServices": "Special services",
    "serviceWorklist": "Worklist",
    "serviceCatalog": "Services & prices",
    "pos": "Medical POS",
    "posCounter": "Sell",
    "salesHistory": "Sales history",
    "itemsPrices": "Items & prices",
    "finance": "Finance",
    "collapseMenu": "Collapse menu",
    "expandMenu": "Expand menu",
    "posStock": "Stock & refills",
    "posCatalog": "Catalog & prices",
    "diseases": "Diseases",
    "nationalReporting": "National reporting",
    "area": {
      "patientAdmin": "Patient administration",
      "clinical": "Clinical care",
      "eye": "Eye center",
      "inpatient": "Inpatient",
      "supplies": "Supplies",
      "finance": "Finance",
      "reporting": "Performance & national reporting",
      "engagement": "Patient engagement",
      "platform": "Platform & administration"
    },
    "tenants": "Tenants & hospitals",
    "referrals": "Referrals",
    "followUps": "Follow-ups",
    "duplicates": "Duplicate patients",
    "roles": "Roles & permissions",
    "appointmentDashboard": "Dashboard",
    "appointmentList": "Appointment list",
    "disabilityTypes": "Disability types",
    "queueDashboard": "Staff dashboard",
    "queueKiosk": "Self-service kiosk",
    "queueDisplay": "Waiting-room display",
    "queueReport": "Waiting times",
    "queueServices": "Queue service points",
    "staffKpi": "Staff KPIs",
    "staffDashboard": "Dashboard",
    "staffLeaderboard": "Leaderboard",
    "staffTargets": "Targets"
  },
  "auth": {
    "signIn": "Sign in",
    "signInTitle": "Welcome back",
    "signInSubtitle": "Sign in to continue to your hospital workspace.",
    "username": "Username or email",
    "password": "Password",
    "signingIn": "Signing in…",
    "sessionExpired": "Your session has expired. Please sign in again.",
    "changePassword": "Change password",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmPassword": "Confirm new password",
    "passwordMismatch": "Passwords do not match",
    "passwordChanged": "Password changed. Please sign in again.",
    "passwordPolicy": "At least 8 characters with upper-case, lower-case and a number.",
    "switchHospital": "Switch hospital",
    "hospital": "Hospital",
    "demoAccounts": "Demo accounts",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "usernamePlaceholder": "e.g. doctor",
    "featureClinical": "Patients, visits, pharmacy, laboratory and billing in one place",
    "featureAnalytics": "Live dashboards and year-over-year analytics",
    "featureLanguages": "Lao, Thai, English, Chinese and Vietnamese — fully customizable",
    "featureSecurity": "Role-based access with a complete audit trail",
    "stats": {
      "title": "Live statistics",
      "patients": "Patients registered",
      "newThisMonth": "+{{count}} this month",
      "visitsThisYear": "Visits this year",
      "today": "{{count}} today",
      "eyeExams": "Eye examinations",
      "surgeries": "{{count}} eye surgeries",
      "villages": "Villages served",
      "provinces": "in {{count}} provinces",
      "departments": "Clinical departments",
      "practitioners": "{{count}} doctors",
      "appAccounts": "Patient app users",
      "patientApp": "on the mobile app",
      "visitsByMonth": "Visits per month (last 12 months)"
    },
    "app": {
      "title": "Mobile apps",
      "download": "Download APK",
      "scan": "Scan with your phone",
      "howTo": "How to install",
      "step1": "Download the APK on your Android phone (Android 7.0 or newer).",
      "step2": "Open the file and allow installing apps from this source when asked.",
      "step3": "Open the app: patients create an account with their phone or e-mail; staff sign in with their user name.",
      "version": "Android · version {{version}} · {{date}}",
      "patient": {
        "name": "HMS Patient",
        "desc": "For patients: sign up with phone or e-mail, see your records, queue and bills"
      },
      "staff": {
        "name": "HMS Staff",
        "desc": "For hospital staff: sign in with your HMS user account"
      }
    }
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Cannot reach the server. Check your connection.",
    "UNAUTHORIZED": "Please sign in to continue.",
    "INVALID_CREDENTIALS": "Incorrect username or password.",
    "ACCOUNT_LOCKED": "Account temporarily locked after repeated failed attempts. Try again later.",
    "ACCOUNT_DISABLED": "This account is disabled. Contact the hospital.",
    "TOKEN_INVALID": "Your session is no longer valid. Please sign in again.",
    "TOKEN_REUSED": "Your session was ended for safety. Please sign in again.",
    "SESSION_EXPIRED": "Your session has expired. Please sign in again.",
    "NO_HOSPITAL_ACCESS": "Your account has no hospital access yet.",
    "HOSPITAL_ACCESS_DENIED": "You do not have access to that hospital.",
    "FORBIDDEN": "You do not have permission to do this.",
    "NOT_FOUND": "The requested record was not found.",
    "VALIDATION_FAILED": "Please correct the highlighted fields.",
    "INVALID_JSON": "The request could not be read.",
    "INVALID_PARAMETER": "A filter value is invalid.",
    "DUPLICATE": "A record with the same value already exists.",
    "CONFLICT": "This conflicts with existing data.",
    "VERSION_CONFLICT": "Someone else changed this record. Reload and try again.",
    "SCHEDULE_CONFLICT": "That time overlaps another booking for this practitioner.",
    "INVALID_STATE": "This action is not allowed in the current state.",
    "INVALID_TRANSITION": "This action is not allowed in the current status.",
    "MRN_EXISTS": "This MRN is already in use.",
    "DUPLICATE_IDENTIFIER": "A patient with this identifier already exists.",
    "POTENTIAL_DUPLICATE": "A similar patient already exists.",
    "ALLERGY_WARNING": "The medication matches a documented allergy.",
    "OVERPAYMENT": "The amount exceeds the outstanding balance.",
    "TOO_MANY_REQUESTS": "Too many requests. Please wait a moment.",
    "INTERNAL_ERROR": "An unexpected server error occurred.",
    "UNSIGNED_NOTES": "Sign or remove draft notes before completing.",
    "ENCOUNTER_CLOSED": "This encounter is closed.",
    "ENCOUNTER_EXISTS": "An encounter already exists for this appointment.",
    "ENCOUNTER_HAS_ACTIVITY": "Encounters with signed notes or orders cannot be cancelled.",
    "QUEUE_CLOSED": "The queue for this department is closed.",
    "INVOICE_HAS_PAYMENTS": "Refund payments before voiding the invoice.",
    "EMPTY_INVOICE": "Add at least one item to the invoice.",
    "SPECIMEN_NOT_COLLECTED": "Collect the specimen before entering results.",
    "RESULT_VERIFIED": "Verified results must be corrected, not re-entered.",
    "NOTHING_TO_DISPENSE": "Nothing left to dispense.",
    "QUANTITY_EXCEEDED": "Quantity exceeds what was prescribed.",
    "CANNOT_DISABLE_SELF": "You cannot disable your own account.",
    "CONSTRAINT_VIOLATION": "The data violates a clinical or business rule.",
    "INVALID_REFERENCE": "A referenced record does not exist.",
    "PATIENT_INACTIVE": "This patient record is not active.",
    "PATIENT_MISMATCH": "The selected record belongs to another patient.",
    "NOTE_SIGNED": "Signed notes cannot be edited; create an amendment.",
    "NOTE_NOT_SIGNED": "Only signed notes can be amended.",
    "NO_DEPARTMENT": "Choose a department first.",
    "IDEMPOTENCY_KEY_REUSED": "This payment request was already used for another invoice.",
    "LOCALE_REQUIRED": "English cannot be disabled.",
    "RETRY": "The record was busy. Please try again.",
    "EXAM_SIGNED": "This examination is signed. Create an amendment to change it.",
    "EXAM_EMPTY": "Record at least one finding before signing.",
    "EXAM_EXISTS": "This visit already has an open eye examination.",
    "EXAM_NOT_SIGNED": "Only signed examinations can be amended.",
    "EYE_SIDE_MISMATCH": "Eye mismatch: the eye does not match the plan or the measurement.",
    "PREOP_NOT_CONFIRMED": "Complete the pre-operative safety checklist first.",
    "BIOMETRY_REQUIRED": "Cataract surgery needs biometry for the operated eye.",
    "IOL_NOT_SELECTED": "Select the intraocular lens before confirming.",
    "IOL_POWER_MISMATCH": "The implanted lens power differs from the selected plan.",
    "IMPLANT_EXPIRED": "The implant is expired.",
    "MEDICATION_EXPIRED": "The medication lot is expired.",
    "IOL_OUT_OF_RANGE": "Measurements are outside the formula range.",
    "BIOMETRY_LOCKED": "This biometry was already used for surgery.",
    "DATE_IN_PAST": "The date is in the past.",
    "PATHWAY_SHARED": "Shared templates are read-only. Copy it to your hospital to customise.",
    "STAGE_IN_USE": "A stage with patients on it cannot be removed.",
    "PATHWAY_ARCHIVED": "This treatment cycle is archived.",
    "ACTIVATION_INVALID": "The activation code is invalid or expired.",
    "OTP_INVALID": "The code is incorrect.",
    "OTP_EXPIRED": "The code has expired. Request a new one.",
    "OTP_LOCKED": "Too many wrong codes. Request a new one.",
    "OTP_RATE_LIMITED": "Too many codes requested. Try again later.",
    "VERIFICATION_REQUIRED": "Please show your ID card at the registration desk first.",
    "QUEUE_PAUSED": "Getting a ticket from the app is paused for this department.",
    "EID_INVALID": "This QR code is invalid or expired. Ask the patient to refresh it.",
    "EID_OTHER_HOSPITAL": "This QR code belongs to another hospital.",
    "PHOTO_TOO_LARGE": "The photo must be an image of at most 2 MB",
    "PHOTO_INVALID": "Upload a JPEG, PNG or WebP image",
    "SUBDISTRICT_IN_USE": "Patients live in this subdistrict; it cannot be deleted",
    "INSUFFICIENT_STOCK": "Not enough usable stock",
    "SELF_APPROVAL": "Someone else must check or approve what you prepared yourself",
    "NO_DISPENSING_STORE": "No active dispensing store is set up",
    "NOTHING_APPROVED": "Approve at least one line, or reject the request",
    "DUPLICATE_LINE": "Each item may appear only once",
    "DISCOUNT_EXCEEDS_BALANCE": "The discount would bring the bill below what has already been paid",
    "BED_UNAVAILABLE": "This bed is not free",
    "BED_OCCUPIED": "A patient is in this bed",
    "ALREADY_ADMITTED": "The patient is already admitted",
    "WARD_OCCUPIED": "Patients are still in this ward",
    "ROOM_OCCUPIED": "A bed in this room is occupied",
    "DISCHARGE_PENDING": "There is unfinished work for this admission",
    "ADMISSION_HAS_ACTIVITY": "Orders or bills exist; discharge the patient instead",
    "SAME_BED": "The patient is already in this bed",
    "ALREADY_BILLED": "It is on an invoice; void the invoice first",
    "NOT_FOR_SALE": "This item is not for sale",
    "PATIENT_REQUIRED": "Choose the patient for controlled items",
    "NO_CASH_SESSION": "Open your cash drawer first",
    "SESSION_OPEN": "You already have an open cash drawer",
    "SESSION_CLOSED": "That cash drawer is closed; record a return instead",
    "STORE_INACTIVE": "The store is not in use",
    "TOO_MANY_IMAGES": "Too many pictures",
    "POS_REFILL_ONLY": "Stock for a POS outlet is sent from a POS refill request",
    "POS_OUTLET": "POS outlet stock changes only through refills and sales",
    "NOT_A_POS_OUTLET": "Sales are made from a POS outlet",
    "NOT_IN_CATALOG": "Only products in the POS catalog can be requested",
    "NOTHING_TO_SEND": "Nothing to send: the store has none of the requested items",
    "EXCEEDS_SENT": "More received than was sent",
    "DUPLICATE_CODE": "This code is already used",
    "TYPE_IN_USE": "This disease type still has diseases. Move them or deactivate the type instead.",
    "SEGREGATION_OF_DUTIES": "Someone other than the author must approve this",
    "NOT_DRAFT": "Only a draft can do this",
    "NOT_VALIDATED": "Validate it first",
    "NOT_APPROVED": "It must be approved first",
    "SNAPSHOT_HAS_ERRORS": "The snapshot has errors; fix them and generate a new version",
    "HASH_MISMATCH": "The snapshot content no longer matches its fingerprint",
    "SNAPSHOT_FINAL": "This snapshot can no longer change",
    "SNAPSHOT_NOT_APPROVED": "The report snapshot must be approved",
    "OPEN_BATCH_EXISTS": "Another batch for the same data is still open",
    "MAPPING_OVERLAP": "Another mapping already covers these dates; retire it first",
    "METADATA_MISSING": "Refresh the DHIS2 metadata first",
    "INSTANCE_DISABLED": "This DHIS2 connection is disabled",
    "NOT_RETRYABLE": "This batch cannot be sent again",
    "NOT_RECONCILABLE": "Only a sent batch can be reconciled",
    "NOT_CANCELLABLE": "This batch can no longer be cancelled",
    "INVALID_PERIOD": "Enter a period like 202610, 2026Q4 or 2026",
    "PERIOD_TYPE_MISMATCH": "The period does not match the report frequency",
    "REPORT_RETIRED": "This report is retired",
    "REPORT_EMPTY": "This report has no active KPIs",
    "NO_DIRECTION": "Set whether higher or lower is better first",
    "DUPLICATE_NAME": "This name is already used",
    "UNKNOWN_CALCULATOR": "Unknown calculator",
    "CONCURRENT_CHANGE": "It changed meanwhile; try again",
    "ALREADY_RETIRED": "Already retired",
    "OWN_TENANT": "You cannot suspend the tenant you are signed in to",
    "OWN_HOSPITAL": "You cannot deactivate the hospital you are signed in to",
    "REFERRAL_CLOSED": "A finished referral cannot be changed",
    "PATIENT_MERGED": "This patient record was merged into another one",
    "MERGE_PENDING": "A merge of these two records is already waiting for approval",
    "BOTH_ADMITTED": "Both records have a patient in the ward; discharge one admission first",
    "FOLLOW_UP_CLOSED": "This follow-up is already finished",
    "NOT_REQUESTED": "This request was already decided",
    "ROLE_LOCKED": "The super administrator always has every permission",
    "ROLE_BUILT_IN": "Built-in roles cannot be deleted; remove their permissions instead",
    "ROLE_IN_USE": "This role is still given to users",
    "DISABILITY_TYPE_IN_USE": "Patients have this disability type. Deactivate it instead.",
    "DISABILITY_TYPE_HAS_SUB_TYPES": "Delete or move its sub-types first."
  },
  "validation": {
    "required": "Required",
    "invalid": "Invalid value",
    "invalidType": "Invalid value",
    "tooLong": "Too long",
    "invalidOption": "Choose a valid option",
    "invalidDate": "Enter a valid date",
    "invalidDateTime": "Enter a valid date and time",
    "invalidNumber": "Enter a number",
    "invalidInteger": "Enter a whole number",
    "outOfRange": "Value is out of range",
    "invalidEmail": "Enter a valid email address",
    "invalidPhone": "Enter a valid phone number",
    "implausibleDate": "Date is not plausible",
    "weakPassword": "Password is too weak",
    "incorrect": "Incorrect",
    "inPast": "Time is in the past",
    "invalidKey": "Invalid translation key",
    "invalidValue": "Invalid translation text",
    "tooMany": "Too many entries",
    "mustConfirm": "Must be confirmed",
    "eyeSideMismatch": "Eye does not match the study",
    "beforeStart": "Must be after the start date",
    "invalidUrl": "Enter a valid link",
    "exceedsOutstanding": "More than is still outstanding",
    "expired": "Already expired",
    "exceedsAvailable": "More than is available",
    "insufficient": "Not enough",
    "duplicate": "Listed twice",
    "min": "Too small",
    "max": "Too large",
    "notDiscountable": "This fee cannot be discounted",
    "belowMin": "Must not be below the minimum",
    "inFuture": "Cannot be in the future",
    "tooOld": "Too far in the past (30 days at most)",
    "beforeAdmission": "Cannot be before the admission or the last bed move",
    "httpsRequired": "Production needs https",
    "notFound": "Not found",
    "notAllowed": "Not allowed here",
    "platformOnly": "Only the super administrator can have platform permissions",
    "disabilityAlone": "This type cannot be combined with other types",
    "disabilityOneSubtype": "Choose only one sub-type here",
    "tooDeep": "Too many levels"
  },
  "enums": {
    "sex": {
      "MALE": "Male",
      "FEMALE": "Female",
      "OTHER": "Other",
      "UNKNOWN": "Unknown"
    },
    "maritalStatus": {
      "SINGLE": "Single",
      "MARRIED": "Married",
      "DIVORCED": "Divorced",
      "WIDOWED": "Widowed",
      "SEPARATED": "Separated",
      "UNKNOWN": "Unknown"
    },
    "patientStatus": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "DECEASED": "Deceased",
      "MERGED": "Merged"
    },
    "appointmentStatus": {
      "BOOKED": "Booked",
      "CONFIRMED": "Confirmed",
      "CHECKED_IN": "Checked in",
      "IN_PROGRESS": "In progress",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled",
      "NO_SHOW": "No-show"
    },
    "encounterStatus": {
      "PLANNED": "Planned",
      "IN_PROGRESS": "In progress",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "encounterType": {
      "OPD": "Outpatient",
      "IPD": "Inpatient",
      "EMERGENCY": "Emergency",
      "TELEMEDICINE": "Telemedicine",
      "HOME_VISIT": "Home visit"
    },
    "ticketStatus": {
      "WAITING": "Waiting",
      "CALLED": "Called",
      "SERVING": "Serving",
      "SERVED": "Served",
      "SKIPPED": "Skipped",
      "CANCELLED": "Cancelled",
      "TRANSFERRED": "Sent on"
    },
    "queuePriority": {
      "NORMAL": "Normal",
      "URGENT": "Urgent",
      "EMERGENCY": "Emergency",
      "PRIORITY": "Priority"
    },
    "labPriority": {
      "ROUTINE": "Routine",
      "URGENT": "Urgent",
      "STAT": "STAT"
    },
    "labOrderStatus": {
      "ORDERED": "Ordered",
      "COLLECTED": "Collected",
      "IN_PROGRESS": "In progress",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "labItemStatus": {
      "ORDERED": "Ordered",
      "RESULTED": "Resulted",
      "VERIFIED": "Verified",
      "CANCELLED": "Cancelled"
    },
    "resultStatus": {
      "PRELIMINARY": "Preliminary",
      "VERIFIED": "Verified",
      "CORRECTED": "Corrected"
    },
    "resultFlag": {
      "N": "Normal",
      "L": "Low",
      "H": "High",
      "LL": "Critical low",
      "HH": "Critical high",
      "A": "Abnormal"
    },
    "prescriptionStatus": {
      "ISSUED": "Issued",
      "PARTIALLY_DISPENSED": "Partially dispensed",
      "DISPENSED": "Dispensed",
      "CANCELLED": "Cancelled"
    },
    "invoiceStatus": {
      "DRAFT": "Draft",
      "ISSUED": "Unpaid",
      "PARTIALLY_PAID": "Partially paid",
      "PAID": "Paid",
      "VOID": "Void"
    },
    "paymentStatus": {
      "PENDING": "Pending",
      "COMPLETED": "Completed",
      "FAILED": "Failed",
      "REFUNDED": "Refunded"
    },
    "paymentMethod": {
      "CASH": "Cash",
      "CARD": "Card",
      "BANK_TRANSFER": "Bank transfer",
      "QR": "QR payment",
      "MOBILE_MONEY": "Mobile money",
      "INSURANCE": "Insurance"
    },
    "allergySeverity": {
      "MILD": "Mild",
      "MODERATE": "Moderate",
      "SEVERE": "Severe",
      "LIFE_THREATENING": "Life-threatening"
    },
    "allergyStatus": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "RESOLVED": "Resolved",
      "ENTERED_IN_ERROR": "Entered in error"
    },
    "alertSeverity": {
      "INFO": "Info",
      "WARNING": "Warning",
      "CRITICAL": "Critical"
    },
    "noteType": {
      "SOAP": "SOAP",
      "PROGRESS": "Progress",
      "ADMISSION": "Admission",
      "DISCHARGE": "Discharge",
      "NURSING": "Nursing",
      "CONSULT": "Consultation",
      "PROCEDURE": "Procedure"
    },
    "noteStatus": {
      "DRAFT": "Draft",
      "SIGNED": "Signed",
      "AMENDED": "Amended"
    },
    "diagnosisType": {
      "PRIMARY": "Primary",
      "SECONDARY": "Secondary",
      "ADMITTING": "Admitting",
      "DISCHARGE": "Discharge",
      "DIFFERENTIAL": "Differential"
    },
    "verificationStatus": {
      "PROVISIONAL": "Provisional",
      "CONFIRMED": "Confirmed",
      "REFUTED": "Refuted",
      "ENTERED_IN_ERROR": "Entered in error"
    },
    "departmentType": {
      "CLINICAL": "Clinical",
      "DIAGNOSTIC": "Diagnostic",
      "SUPPORT": "Support",
      "ADMINISTRATIVE": "Administrative"
    },
    "userStatus": {
      "ACTIVE": "Active",
      "LOCKED": "Locked",
      "DISABLED": "Disabled"
    },
    "role": {
      "SUPER_ADMIN": "Super administrator",
      "HOSPITAL_ADMIN": "Hospital administrator",
      "DOCTOR": "Doctor",
      "NURSE": "Nurse",
      "RECEPTIONIST": "Receptionist",
      "PHARMACIST": "Pharmacist",
      "LAB_TECHNICIAN": "Laboratory staff",
      "CASHIER": "Cashier",
      "OPTOMETRIST": "Optometrist",
      "INVENTORY_MANAGER": "Inventory manager",
      "PROCUREMENT_APPROVER": "Procurement approver",
      "IMAGING_TECHNICIAN": "Imaging technician",
      "ACCOUNTANT": "Finance officer",
      "POS_MANAGER": "POS manager",
      "REPORTING_OFFICER": "National reporting officer",
      "REPORTING_APPROVER": "Reporting approver",
      "SYSTEM_ADMIN": "System administrator",
      "HOSPITAL_DIRECTOR": "Hospital director",
      "MEDICAL_DIRECTOR": "Medical director",
      "OPHTHALMOLOGIST": "Ophthalmologist",
      "OPHTHALMIC_SURGEON": "Ophthalmic surgeon",
      "OPHTHALMIC_NURSE": "Ophthalmic nurse",
      "DIAGNOSTIC_TECHNICIAN": "Diagnostic technician",
      "MEDICAL_RECORDS_OFFICER": "Medical records officer",
      "AUDITOR": "Auditor",
      "QUEUE_DEVICE": "Kiosk / display device"
    },
    "medicationOrderStatus": {
      "ACTIVE": "To dispense",
      "COMPLETED": "Dispensed",
      "CANCELLED": "Cancelled"
    },
    "eyeExamStatus": {
      "DRAFT": "Draft",
      "IN_PROGRESS": "In progress",
      "SIGNED": "Signed",
      "AMENDED": "Amended",
      "CANCELLED": "Cancelled"
    },
    "surgeryStatus": {
      "PLANNED": "Planned",
      "CONFIRMED": "Checklist confirmed",
      "IN_PROGRESS": "In surgery",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "followUpStatus": {
      "SCHEDULED": "Scheduled",
      "COMPLETED": "Done",
      "MISSED": "Missed",
      "CANCELLED": "Cancelled"
    },
    "eyeMedStatus": {
      "ACTIVE": "Active",
      "COMPLETED": "Completed",
      "STOPPED": "Stopped"
    },
    "carePlanStatus": {
      "ACTIVE": "Active",
      "COMPLETED": "Completed",
      "STOPPED": "Stopped"
    },
    "portalStatus": {
      "ACTIVE": "App active",
      "DISABLED": "App disabled"
    },
    "portalVerification": {
      "VERIFIED": "Identity verified",
      "PENDING_VERIFICATION": "ID check pending"
    },
    "queueStatus": {
      "OPEN": "Open",
      "PAUSED": "App check-in paused",
      "CLOSED": "Closed"
    },
    "inventoryItemType": {
      "DRUG": "Drug",
      "SUPPLY": "Medical supply",
      "EQUIPMENT": "Equipment",
      "DEVICE": "Medical device (for sale)"
    },
    "stockStatus": {
      "OUT": "Out of stock",
      "LOW": "Low",
      "OK": "In stock",
      "OVER": "Overstocked",
      "ASSET": "Per device",
      "EXPIRING": "Expiring ≤ 90 days"
    },
    "expiryStatus": {
      "EXPIRED": "Expired",
      "EXPIRING": "Expiring"
    },
    "lotStatus": {
      "AVAILABLE": "Available",
      "QUARANTINE": "Quarantine"
    },
    "movementType": {
      "OPENING": "Opening balance",
      "RECEIPT": "Goods receipt",
      "DISPENSE": "Dispensed (prescription)",
      "ISSUE": "Issued to department",
      "TRANSFER_OUT": "Transfer out",
      "TRANSFER_IN": "Transfer in",
      "ADJUSTMENT_IN": "Adjustment (+)",
      "ADJUSTMENT_OUT": "Adjustment (−)",
      "WRITE_OFF": "Write-off",
      "RETURN_TO_SUPPLIER": "Return to supplier",
      "SALE": "Counter sale",
      "SALE_RETURN": "Sale return"
    },
    "adjustmentReason": {
      "OPENING_BALANCE": "Opening balance",
      "COUNT_CORRECTION": "Stock count correction",
      "DONATION": "Donation",
      "FOUND": "Found",
      "EXPIRED": "Expired",
      "DAMAGED": "Damaged",
      "LOST": "Lost",
      "RECALLED": "Recalled by maker",
      "DEFECTIVE": "Defective",
      "OTHER": "Other"
    },
    "prStatus": {
      "DRAFT": "Draft",
      "SUBMITTED": "Waiting for approval",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "ORDERED": "Ordered",
      "CANCELLED": "Cancelled"
    },
    "prPriority": {
      "NORMAL": "Normal",
      "URGENT": "Urgent"
    },
    "poStatus": {
      "DRAFT": "Draft",
      "APPROVED": "Approved",
      "SENT": "Sent to supplier",
      "PARTIALLY_RECEIVED": "Partly received",
      "RECEIVED": "Received",
      "CLOSED": "Closed",
      "CANCELLED": "Cancelled"
    },
    "storeType": {
      "MAIN": "Main store",
      "PHARMACY": "Pharmacy",
      "WARD": "Ward store",
      "CLINIC": "Clinic store",
      "POS": "POS outlet"
    },
    "assetStatus": {
      "IN_SERVICE": "In service",
      "UNDER_MAINTENANCE": "Under maintenance",
      "OUT_OF_SERVICE": "Out of service",
      "DISPOSED": "Disposed"
    },
    "assetEvent": {
      "MAINTENANCE": "Preventive maintenance",
      "CALIBRATION": "Calibration",
      "INSPECTION": "Inspection",
      "REPAIR": "Repair",
      "STATUS_CHANGE": "Status change",
      "TRANSFER": "Moved"
    },
    "maintenanceStatus": {
      "OK": "On schedule",
      "DUE": "Due ≤ 30 days",
      "OVERDUE": "Overdue",
      "NONE": "—"
    },
    "stockUnit": {
      "TABLET": "Tablet",
      "CAPSULE": "Capsule",
      "BOTTLE": "Bottle",
      "VIAL": "Vial",
      "AMPOULE": "Ampoule",
      "SACHET": "Sachet",
      "TUBE": "Tube",
      "INHALER": "Inhaler",
      "PIECE": "Piece",
      "BOX": "Box",
      "PACK": "Pack",
      "ROLL": "Roll",
      "SYRINGE": "Syringe",
      "SET": "Set",
      "UNIT": "Unit"
    },
    "bedStatus": {
      "AVAILABLE": "Free",
      "OCCUPIED": "Occupied",
      "CLEANING": "Cleaning",
      "RESERVED": "Reserved",
      "OUT_OF_SERVICE": "Out of service"
    },
    "roomType": {
      "STANDARD": "Standard",
      "PRIVATE": "Private",
      "VIP": "VIP",
      "ICU": "Intensive care",
      "OBSERVATION": "Observation",
      "ISOLATION": "Isolation"
    },
    "wardType": {
      "GENERAL": "General",
      "SURGICAL": "Surgical",
      "PEDIATRIC": "Children",
      "MATERNITY": "Maternity",
      "ICU": "Intensive care",
      "OBSERVATION": "Observation",
      "ISOLATION": "Isolation",
      "PRIVATE": "Private"
    },
    "bedType": {
      "STANDARD": "Standard",
      "ELECTRIC": "Electric",
      "ICU": "ICU",
      "PEDIATRIC": "Child",
      "CRIB": "Crib"
    },
    "admissionType": {
      "EMERGENCY": "Emergency",
      "ELECTIVE": "Planned",
      "TRANSFER_IN": "Transferred in",
      "DAY_CASE": "Day case",
      "MATERNITY": "Maternity"
    },
    "admissionStatus": {
      "ADMITTED": "In hospital",
      "DISCHARGED": "Discharged",
      "CANCELLED": "Cancelled"
    },
    "dischargeType": {
      "HOME": "Home",
      "REFERRED": "Referred",
      "AGAINST_ADVICE": "Against advice",
      "TRANSFERRED": "Transferred",
      "DECEASED": "Deceased"
    },
    "stayReason": {
      "ADMISSION": "Admission",
      "TRANSFER": "Bed transfer"
    },
    "serviceCategory": {
      "XRAY": "X-ray",
      "CT": "CT scan",
      "MRI": "MRI",
      "ULTRASOUND": "Ultrasound",
      "ECG": "ECG",
      "ECHO": "Echocardiography",
      "ENDOSCOPY": "Endoscopy",
      "PHYSIOTHERAPY": "Physiotherapy",
      "DENTAL": "Dental",
      "PROCEDURE": "Procedure",
      "OTHER": "Other"
    },
    "serviceOrderStatus": {
      "ORDERED": "Ordered",
      "IN_PROGRESS": "In progress",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "serviceItemStatus": {
      "ORDERED": "Waiting",
      "IN_PROGRESS": "In progress",
      "REPORTED": "Reported",
      "VERIFIED": "Verified",
      "CANCELLED": "Cancelled"
    },
    "saleStatus": {
      "COMPLETED": "Paid",
      "PARTIALLY_RETURNED": "Partly returned",
      "RETURNED": "Returned",
      "VOIDED": "Voided"
    },
    "stockDocType": {
      "RECEIPT": "Goods received",
      "OPENING": "Opening stock",
      "ADJUSTMENT_IN": "Adjustment in",
      "ISSUE": "Requisition",
      "TRANSFER": "Transfer",
      "ADJUSTMENT_OUT": "Adjustment out",
      "WRITE_OFF": "Write-off",
      "RETURN_TO_SUPPLIER": "Return to supplier"
    },
    "stockDocStatus": {
      "DRAFT": "Draft",
      "SUBMITTED": "Waiting for check",
      "POSTED": "Posted",
      "REJECTED": "Rejected",
      "CANCELLED": "Cancelled",
      "IN_TRANSIT": "In transit"
    },
    "expenseCategory": {
      "SUPPLIES": "Supplies",
      "UTILITIES": "Electricity & water",
      "SALARIES": "Salaries",
      "MAINTENANCE": "Maintenance",
      "RENT": "Rent",
      "TRANSPORT": "Transport",
      "MARKETING": "Marketing",
      "TRAINING": "Training",
      "TAXES": "Taxes & fees",
      "OTHER": "Other"
    },
    "expenseStatus": {
      "SUBMITTED": "Waiting for approval",
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "CANCELLED": "Cancelled"
    },
    "cashSessionStatus": {
      "OPEN": "Open",
      "CLOSED": "Closed – to verify",
      "VERIFIED": "Verified"
    },
    "priceType": {
      "CHARGE_ITEM": "Fees",
      "SERVICE": "Special services",
      "MEDICATION": "Drugs",
      "LAB_TEST": "Lab tests",
      "ROOM": "Bed rates",
      "INVENTORY_ITEM": "Warehouse suggested price",
      "POS_PRODUCT": "Medical POS"
    },
    "priceStatus": {
      "ACTIVE": "In use",
      "INACTIVE": "Not in use",
      "DISCONTINUED": "Discontinued",
      "NOT_FOR_SALE": "Not for sale"
    },
    "discountType": {
      "AMOUNT": "Amount",
      "PERCENT": "Percent"
    },
    "plSection": {
      "REVENUE": "Revenue",
      "COST": "Cost of goods",
      "EXPENSES": "Expenses",
      "RESULT": "Result"
    },
    "plLine": {
      "INVOICES": "Patient bills",
      "POS_SALES": "Counter sales",
      "REFUNDS": "Refunds",
      "TOTAL_REVENUE": "Total revenue",
      "COST_OF_GOODS": "Drugs and supplies used",
      "GROSS_PROFIT": "Gross profit",
      "TOTAL_EXPENSES": "Total expenses",
      "NET_PROFIT": "Net profit"
    },
    "posLevel": {
      "OK": "OK",
      "LOW": "Low",
      "OUT": "Out of stock"
    },
    "posProductStatus": {
      "PUBLISHED": "Shown at POS",
      "HIDDEN": "Hidden"
    },
    "outletStatus": {
      "ACTIVE": "In use",
      "INACTIVE": "Not in use"
    },
    "refillStatus": {
      "DRAFT": "Draft",
      "SUBMITTED": "Waiting for warehouse",
      "PREPARING": "Being prepared",
      "IN_TRANSIT": "On its way",
      "RECEIVED": "Received",
      "REJECTED": "Rejected",
      "CANCELLED": "Cancelled"
    },
    "patientTitle": {
      "MR": "Mr (ທ້າວ)",
      "MRS": "Mrs (ນາງ)",
      "MISS": "Miss (ນາງສາວ)",
      "BOY": "Boy (ເດັກຊາຍ)",
      "GIRL": "Girl (ເດັກຍິງ)",
      "DR": "Dr (ດຣ.)",
      "MONK": "Monk (ພຣະ)",
      "NOVICE": "Novice monk (ສາມະເນນ)",
      "NUN": "Nun (ແມ່ຂາວ)"
    },
    "reporting": {
      "ACHIEVED": "Achieved",
      "WARNING": "Warning",
      "MISSED": "Missed",
      "INSUFFICIENT_DATA": "Insufficient data",
      "NOT_APPLICABLE": "No target",
      "PENDING_REVIEW": "Pending review",
      "OK": "OK",
      "INCOMPLETE": "Incomplete",
      "INVALID": "Invalid",
      "DRAFT": "Draft",
      "VALIDATED": "Validated",
      "APPROVED": "Approved",
      "SUPERSEDED": "Superseded",
      "INVALIDATED": "Invalidated",
      "ACTIVE": "Active",
      "RETIRED": "Retired",
      "QUEUED": "Queued",
      "SUBMITTING": "Sending",
      "ACCEPTED": "Accepted",
      "PARTIALLY_ACCEPTED": "Partly accepted",
      "REJECTED": "Rejected",
      "RETRY_PENDING": "Retry pending",
      "RECONCILIATION_REQUIRED": "Needs reconciliation",
      "CANCELLED": "Cancelled",
      "PENDING": "Pending",
      "IGNORED": "Ignored"
    },
    "kpiCategory": {
      "OPERATIONS": "Operations",
      "CLINICAL": "Clinical",
      "SURGERY": "Surgery",
      "EYE_HEALTH": "Eye health",
      "EPIDEMIOLOGY": "Epidemiology",
      "INPATIENT": "Inpatient",
      "SUPPLIES": "Supplies",
      "DATA_QUALITY": "Data quality",
      "STAFF": "Staff"
    },
    "kpiUnit": {
      "COUNT": "Count",
      "PERCENT": "Percent",
      "MINUTES": "Minutes",
      "DAYS": "Days",
      "RATIO": "Ratio"
    },
    "kpiDirection": {
      "HIGHER_BETTER": "Higher is better",
      "LOWER_BETTER": "Lower is better",
      "INFO": "Information only"
    },
    "dimension": {
      "SEX": "Sex",
      "AGE_BAND": "Age group",
      "MALE": "Male",
      "FEMALE": "Female",
      "AGE_0_14": "0–14 years",
      "AGE_15_49": "15–49 years",
      "AGE_50P": "50 years and over"
    },
    "dhis2Env": {
      "MOCK": "Simulator",
      "STAGING": "Test",
      "PRODUCTION": "Production"
    },
    "mappingType": {
      "ORG_UNIT": "Organisation unit",
      "DATA_SET": "Data set",
      "DATA_ELEMENT": "Data element",
      "CATEGORY_OPTION": "Category option"
    },
    "valueTransform": {
      "NONE": "As calculated",
      "ROUND": "Whole number",
      "ONE_DECIMAL": "One decimal"
    },
    "metadataKind": {
      "ORG_UNIT": "Org units",
      "DATA_SET": "Data sets",
      "DATA_ELEMENT": "Data elements",
      "CATEGORY_OPTION_COMBO": "Category combos",
      "ATTRIBUTE_OPTION_COMBO": "Attribute combos"
    },
    "tenantType": {
      "HEALTHCARE_GROUP": "Healthcare group",
      "HOSPITAL": "Hospital",
      "CLINIC": "Clinic",
      "GOVERNMENT": "Government",
      "NGO": "NGO"
    },
    "tenantStatus": {
      "ACTIVE": "Active",
      "SUSPENDED": "Suspended",
      "INACTIVE": "Inactive"
    },
    "referralStatus": {
      "REQUESTED": "Requested",
      "SENT": "Sent",
      "ACCEPTED": "Accepted",
      "DECLINED": "Declined",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled",
      "UNREACHABLE": "Not reachable"
    },
    "referralDirection": {
      "OUT": "Referred out",
      "IN": "Referred in"
    },
    "referralPriority": {
      "ROUTINE": "Routine",
      "URGENT": "Urgent",
      "EMERGENCY": "Emergency"
    },
    "referralTransport": {
      "SELF": "On their own",
      "FAMILY": "With family",
      "AMBULANCE": "Ambulance",
      "HOSPITAL_VEHICLE": "Hospital vehicle",
      "OTHER": "Other"
    },
    "referralEvent": {
      "CREATED": "Created",
      "UPDATED": "Updated",
      "SENT": "Sent",
      "ACCEPTED": "Accepted",
      "DECLINED": "Declined",
      "CONTACT_ATTEMPT": "Contact",
      "UNREACHABLE": "Not reachable",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "contactResult": {
      "REACHED": "Reached",
      "NO_ANSWER": "No answer",
      "WRONG_NUMBER": "Wrong number",
      "LEFT_MESSAGE": "Left a message"
    },
    "followUpPriority": {
      "ROUTINE": "Routine",
      "URGENT": "Urgent"
    },
    "mergeStatus": {
      "REQUESTED": "Waiting for approval",
      "APPROVED": "Merged",
      "REJECTED": "Rejected",
      "CANCELLED": "Cancelled"
    },
    "queuePriorityReason": {
      "ELDERLY": "Elderly",
      "DISABILITY": "Disability",
      "PREGNANT": "Pregnant",
      "CHILD": "Young child",
      "CLINICAL": "Clinical",
      "OTHER": "Other"
    },
    "queueStage": {
      "REGISTRATION": "Registration",
      "TRIAGE": "Triage",
      "EXAMINATION": "Examination",
      "CONSULTATION": "Consultation",
      "DIAGNOSTICS": "Diagnostics",
      "SURGERY": "Surgery",
      "PHARMACY": "Pharmacy",
      "CASHIER": "Cashier",
      "OTHER": "Other"
    },
    "queueSource": {
      "DESK": "Front desk",
      "APPOINTMENT": "Appointment check-in",
      "QR": "QR check-in",
      "KIOSK": "Kiosk",
      "MOBILE": "Patient app"
    },
    "queueEvent": {
      "ISSUED": "Ticket issued",
      "CALLED": "Called",
      "RECALLED": "Called again",
      "SERVING": "Service started",
      "COMPLETED": "Completed",
      "SKIPPED": "Skipped (not present)",
      "REQUEUED": "Back in the queue",
      "RETURNED": "Back to waiting",
      "CANCELLED": "Cancelled",
      "TRANSFERRED": "Sent on",
      "PRIORITY_CHANGED": "Priority changed",
      "PATIENT_LINKED": "Patient record linked"
    },
    "queueActor": {
      "STAFF": "Staff",
      "KIOSK": "Kiosk",
      "PATIENT_APP": "Patient app",
      "SYSTEM": "System"
    },
    "queueVisitStatus": {
      "ACTIVE": "In hospital",
      "COMPLETED": "Completed",
      "CANCELLED": "Cancelled"
    },
    "queueServiceStatus": {
      "ACTIVE": "In use",
      "INACTIVE": "Not in use"
    }
  },
  "dashboard": {
    "title": "Dashboard",
    "welcome": "Welcome, {{name}}",
    "subtitle": "Today at {{hospital}}",
    "patientsTotal": "Active patients",
    "registeredToday": "Registered today",
    "appointmentsToday": "Appointments today",
    "queueWaiting": "Waiting in queue",
    "avgWait": "Average wait",
    "openEncounters": "Open encounters",
    "pendingPrescriptions": "Prescriptions to dispense",
    "pendingLabOrders": "Pending lab orders",
    "revenueToday": "Revenue today",
    "outstanding": "Outstanding balance",
    "encountersTrend": "Encounters · last 7 days",
    "revenueTrend": "Revenue · last 7 days",
    "appointmentsByDepartment": "Today's appointments by department",
    "minutes": "{{value}} min",
    "noData": "No data yet",
    "quickActions": "Quick actions"
  },
  "patients": {
    "title": "Patients",
    "register": "Register patient",
    "searchPlaceholder": "Search by name, MRN, phone or national ID",
    "mrn": "MRN",
    "name": "Name",
    "firstName": "First name",
    "middleName": "Middle name",
    "lastName": "Last name",
    "preferredName": "Preferred name",
    "dateOfBirth": "Date of birth",
    "age": "Age",
    "sex": "Sex",
    "bloodGroup": "Blood group",
    "maritalStatus": "Marital status",
    "occupation": "Occupation",
    "nationality": "Nationality",
    "phone": "Phone",
    "email": "Email",
    "address": "Address",
    "emergencyContactName": "Emergency contact",
    "emergencyContactPhone": "Emergency contact phone",
    "nationalId": "National ID",
    "preferredLanguage": "Preferred language",
    "identifiers": "Identifiers",
    "identifierType": "Identifier type",
    "identifierValue": "Identifier number",
    "addIdentifier": "Add identifier",
    "registeredOn": "Registered",
    "sectionPersonal": "Personal details",
    "sectionContact": "Contact",
    "sectionEmergency": "Emergency contact",
    "sectionIdentifiers": "Identifiers",
    "created": "Patient {{mrn}} registered",
    "updated": "Patient record updated",
    "editTitle": "Edit patient",
    "duplicateTitle": "Possible duplicate patient",
    "duplicateMessage": "These existing records look similar. Open one of them, or confirm this is a different person.",
    "duplicateConfirm": "Different person — register anyway",
    "identifierMatchTitle": "Identifier already registered",
    "matchReason": {
      "NAME_AND_BIRTH_DATE": "Same name and date of birth",
      "PHONE_AND_FIRST_NAME": "Same phone and first name"
    },
    "allergies": "Allergies",
    "noKnownAllergies": "No known allergies",
    "addAllergy": "Add allergy",
    "allergen": "Allergen",
    "reaction": "Reaction",
    "severity": "Severity",
    "onsetDate": "Onset date",
    "alerts": "Alerts",
    "addAlert": "Add alert",
    "alertType": "Alert type",
    "alertMessage": "Message",
    "tabOverview": "Overview",
    "tabEncounters": "Encounters",
    "tabAppointments": "Appointments",
    "tabPrescriptions": "Prescriptions",
    "tabLabs": "Lab results",
    "tabInvoices": "Invoices",
    "newEncounter": "Start encounter",
    "bookAppointment": "Book appointment",
    "addToQueue": "Add to queue",
    "empty": "No patients match your search.",
    "pickerPlaceholder": "Search patient by name or MRN",
    "sectionPhoto": "Photo",
    "sectionAddress": "Address",
    "province": "Province",
    "district": "District",
    "subdistrict": "Subdistrict",
    "village": "Village",
    "addressLine": "House no. / street",
    "addressLineHint": "Optional: house number, unit, street or landmark",
    "chooseProvinceFirst": "Choose a province first",
    "chooseDistrictFirst": "Choose a district first",
    "noSubdistricts": "No subdistricts defined",
    "disability": "Disability",
    "takePhoto": "Take photo",
    "choosePhoto": "Choose photo",
    "undoPhoto": "Undo",
    "removePhoto": "Remove photo",
    "photoHint": "JPEG, PNG or WebP. The photo is resized automatically.",
    "photoInvalid": "This file is not a supported image",
    "nameTitle": "Title",
    "noTitle": "— No title —",
    "titleSuggested": "Suggested from sex and age",
    "disabilityDetails": "Disability details"
  },
  "appointments": {
    "title": "Appointments",
    "book": "Book appointment",
    "date": "Date",
    "start": "Start",
    "end": "End",
    "time": "Time",
    "practitioner": "Practitioner",
    "department": "Department",
    "type": "Visit type",
    "reason": "Reason for visit",
    "notes": "Notes",
    "patient": "Patient",
    "anyPractitioner": "All practitioners",
    "anyDepartment": "All departments",
    "checkIn": "Check in",
    "confirm": "Confirm",
    "cancel": "Cancel appointment",
    "noShow": "No-show",
    "startEncounter": "Start encounter",
    "openEncounter": "Open encounter",
    "booked": "Appointment {{number}} booked",
    "checkedIn": "Checked in — ticket {{ticket}}",
    "cancelled": "Appointment cancelled",
    "empty": "No appointments for this day.",
    "priority": "Priority",
    "number": "Number"
  },
  "queue": {
    "title": "Queue",
    "department": "Department",
    "selectDepartment": "Choose a department",
    "callNext": "Call next",
    "counter": "Counter / room",
    "waiting": "Waiting",
    "inService": "Called / in service",
    "served": "Served",
    "ticket": "Ticket",
    "issuedAt": "Issued",
    "recall": "Call again",
    "startService": "Start service",
    "complete": "Done",
    "skip": "Skip",
    "requeue": "Back to queue",
    "cancelTicket": "Cancel ticket",
    "walkIn": "Walk-in ticket",
    "display": "Display screen",
    "nowServing": "Now serving",
    "nextUp": "Next up",
    "empty": "Nobody is waiting.",
    "calling": "Calling {{ticket}}",
    "waitMinutes": "{{value}} min",
    "scanQr": "Scan patient QR",
    "estimatedWait": "Estimated wait for a new patient",
    "min": "min",
    "fromApp": "Tickets from the app",
    "loadDetail": "{{counters}} counter(s) · avg wait {{avg}} min · longest {{longest}} min",
    "open": "Open",
    "pause": "Pause app",
    "pauseHelp": "Stop new tickets from the patient app; the desk can still issue tickets",
    "close": "Close",
    "source": {
      "MOBILE": "From patient app",
      "QR": "Checked in by QR",
      "KIOSK": "From the kiosk"
    },
    "subtitle": "Call, recall, skip, send on and complete patients at your service point",
    "kioskOpen": "Kiosk",
    "report": "Waiting times",
    "servicePoint": "Service point",
    "selectService": "Choose a service point",
    "allServices": "All service points",
    "stage": "Stage",
    "priorityWaiting": "Waiting with priority",
    "nobodyCalled": "Nobody has been called yet. Press “Call next”.",
    "skipped": "Skipped",
    "noSkipped": "No skipped numbers.",
    "done": "Finished",
    "noneDone": "Nobody has finished yet.",
    "waitingTimes": "Waiting-time report",
    "notRegistered": "Not registered yet",
    "assistanceRequested": "Asked for help at the kiosk",
    "priorityRequested": "Asked for priority: {{reason}}",
    "hasDisability": "Disability recorded",
    "age": "{{value}} y",
    "sinceCalled": "Time since called / since service started",
    "waited": "waited {{value}} min",
    "recalled": "called {{value}}× again",
    "findOrRegister": "Find or register patient",
    "openEncounter": "Open encounter",
    "transfer": "Send on",
    "backToQueue": "Back to queue",
    "backToQueueHelp": "Put the patient back on the waiting list (e.g. while eye drops take effect); they keep their place",
    "call": "Call",
    "callThis": "Call this number now (out of turn)",
    "priority": "Priority",
    "cancelTitle": "Cancel ticket {{ticket}}?",
    "cancelHelp": "The number is closed and the patient leaves the queue. This stays in the queue history.",
    "cancelReason": "Reason",
    "transferredIn": "From another queue",
    "setPriority": "Priority of {{ticket}}",
    "priorityHelp": {
      "NORMAL": "In order of arrival",
      "PRIORITY": "Elderly, disability, pregnancy, young child",
      "URGENT": "Clinical: seen before others",
      "EMERGENCY": "Clinical: seen immediately"
    },
    "triageOnly": "Urgent and emergency priority is set by clinical staff.",
    "priorityReason": "Reason for priority",
    "note": "Note",
    "transferTitle": "Send {{ticket}} on",
    "transferHelp": "The patient keeps the same number and joins the chosen queue.",
    "registerFirst": "This patient is not registered yet. Register or find the patient first; until then they can only go to registration.",
    "waitingCount": "{{value}} waiting",
    "handoverNote": "Note for the next service point",
    "handoverNoteHint": "e.g. dilating drops given at 10:15",
    "transferred": "{{ticket}} sent to {{service}}",
    "linkPatientTitle": "Patient for ticket {{ticket}}",
    "linkPatientHelp": "Find the patient's record, or register a new patient (opens in a new tab) and then find them here.",
    "findPatient": "Patient",
    "registerNew": "Register new patient",
    "linkPatient": "Link to ticket",
    "patientLinked": "Patient linked to the ticket",
    "history": "Queue history",
    "historyTitle": "Queue history of {{ticket}}",
    "patient": "Patient",
    "visitStatus": "Visit",
    "timeInHospital": "Time in hospital",
    "encounter": "Encounter",
    "noHistory": "No history yet.",
    "displaySetup": "Set up this display",
    "displaySetupHelp": "Choose the service points this screen shows. The screen's address keeps the choice, so bookmark it in the display's browser.",
    "openDisplay": "Open display",
    "displayTitle": "Queue",
    "nowCalling": "Now calling",
    "pleaseWait": "Please wait for your number",
    "missed": "Missed: please see the desk",
    "displayFooter": "Your number stays the same for your whole visit. Please keep your ticket.",
    "soundOn": "Turn announcements on",
    "soundOff": "Turn announcements off",
    "fullscreen": "Full screen",
    "tapForSound": "Tap to turn on sound",
    "announce": "Number {{ticket}}, please go to {{counter}}, {{service}}",
    "rep": {
      "title": "Queue waiting times",
      "subtitle": "Waiting and service times from the queue history, by service point",
      "today": "Today",
      "week": "7 days",
      "month": "30 days",
      "noData": "No queue tickets in this period.",
      "avgWait": "Average wait",
      "medianWait": "Median wait",
      "p90Wait": "90% called within",
      "p90Hint": "9 in 10 patients waited less than this",
      "maxWait": "Longest wait",
      "waitHint": "From joining a queue to the first call",
      "avgService": "Average service time",
      "avgVisit": "Average visit",
      "visitsCompleted": "{{value}} of {{total}} visits completed",
      "tickets": "Tickets",
      "ticketsHint": "{{served}} served · {{transferred}} sent on",
      "missed": "Skipped (not present)",
      "cancelled": "{{value}} cancelled",
      "kiosk": "Kiosk visits",
      "kioskHint": "{{registered}} registered at the desk · {{help}} asked for help",
      "byHour": "Arrivals by hour of the day",
      "arrivals": "{{value}} arrivals",
      "avgWaitShort": "avg wait {{value}} min",
      "bySourcePriority": "By source and priority",
      "byService": "By service point",
      "transferredOn": "Sent on",
      "byDay": "By day"
    },
    "kiosk": {
      "title": "Self-service check-in",
      "welcome": "Welcome. How can we help you today?",
      "haveAppointment": "I have an appointment today",
      "haveAppointmentHint": "Check in and get your queue number",
      "registeredWalkIn": "I am a patient here, no appointment",
      "registeredWalkInHint": "Get a number for a service",
      "newOrHelp": "New patient, or I need help",
      "newOrHelpHint": "Get a number for the registration desk",
      "emergencyNote": "Emergency? Go straight to the emergency department or tell a staff member.",
      "identifyTitle": "Find your record",
      "mrnOrPhone": "Hospital number (HN) or phone number",
      "birthDate": "Date of birth",
      "day": "Day",
      "month": "Month",
      "year": "Year",
      "delete": "Delete",
      "privacy": "We use these details only to find your record. Nothing personal is shown on screen.",
      "continue": "Continue",
      "hello": "Hello {{name}}.",
      "noAppointment": "We found no appointment for you today.",
      "takeWalkIn": "Get a number for a service",
      "checkIn": "Check in",
      "chooseService": "Where would you like to go?",
      "waitInfo": "{{waiting}} waiting · about {{minutes}} min",
      "priorityQuestion": "Do you need priority service?",
      "priorityHint": "Staff confirm priority when they call you.",
      "request": {
        "ELDERLY": "Aged 60 or over",
        "DISABILITY": "Person with a disability",
        "PREGNANT": "Pregnant",
        "CHILD": "With a young child"
      },
      "notSure": "Not sure where to go? Get a number for the registration desk",
      "helpTitle": "Registration desk",
      "helpText": "Staff at the registration desk will register you or help you, then send you to the right service.",
      "newPatientTicket": "I am a new patient",
      "needHelpTicket": "I need help",
      "registrationTicket": "Get a number for the registration desk",
      "startOver": "Start over",
      "yourNumber": "Your number",
      "ahead": "{{value}} ahead of you · about {{minutes}} min",
      "slipNote": "Please watch the screen for your number. It stays the same for your whole visit.",
      "slipRegistration": "Please wait until your number is called to the registration desk.",
      "alreadyQueued": "You already have a number today. Here it is again.",
      "print": "Print ticket",
      "done": "Done",
      "error": {
        "NOT_FOUND": "We could not find your record with these details.",
        "TOO_MANY_REQUESTS": "Too many attempts. Please ask at the registration desk.",
        "QUEUE_PAUSED": "Self check-in is paused for this service. Please ask at the desk.",
        "QUEUE_CLOSED": "This service is closed today. Please ask at the desk.",
        "NOT_TODAY": "This appointment is not today.",
        "INVALID_TRANSITION": "This appointment cannot be checked in here. Please ask at the desk.",
        "NO_DEPARTMENT": "This appointment cannot be checked in here. Please ask at the desk.",
        "OTHER": "Something went wrong. Please ask at the registration desk."
      }
    }
  },
  "encounters": {
    "title": "Encounters",
    "mine": "My patients",
    "all": "All",
    "today": "Today",
    "number": "Encounter",
    "type": "Type",
    "startedAt": "Started",
    "endedAt": "Ended",
    "chiefComplaint": "Chief complaint",
    "practitioner": "Practitioner",
    "department": "Department",
    "complete": "Complete encounter",
    "completeConfirm": "Complete this encounter? Notes and orders become read-only.",
    "cancel": "Cancel encounter",
    "cancelReason": "Cancellation reason",
    "started": "Encounter {{number}} started",
    "completed": "Encounter completed",
    "vitals": "Vital signs",
    "recordVitals": "Record vitals",
    "temperature": "Temperature",
    "heartRate": "Heart rate",
    "respiratoryRate": "Respiratory rate",
    "bloodPressure": "Blood pressure",
    "systolic": "Systolic",
    "diastolic": "Diastolic",
    "spo2": "SpO₂",
    "weight": "Weight",
    "height": "Height",
    "bmi": "BMI",
    "painScore": "Pain (0–10)",
    "recordedAt": "Recorded",
    "recordedBy": "By",
    "unitCelsius": "°C",
    "unitBpm": "bpm",
    "unitPerMin": "/min",
    "unitMmHg": "mmHg",
    "unitPercent": "%",
    "unitKg": "kg",
    "unitCm": "cm",
    "diagnoses": "Diagnoses",
    "addDiagnosis": "Add diagnosis",
    "diagnosisCode": "ICD-10 code",
    "diagnosisDescription": "Description",
    "diagnosisType": "Type",
    "verification": "Verification",
    "markEnteredInError": "Mark entered in error",
    "notes": "Clinical notes",
    "newNote": "New note",
    "noteType": "Note type",
    "content": "Content",
    "saveDraft": "Save draft",
    "saveAndSign": "Save & sign",
    "sign": "Sign",
    "amend": "Amend",
    "amendReason": "Reason for amendment",
    "amendmentOf": "Amendment of a previous note",
    "signedBy": "Signed by {{name}} · {{time}}",
    "draftBy": "Draft by {{name}}",
    "prescriptions": "Prescriptions",
    "newPrescription": "New prescription",
    "labOrders": "Lab orders",
    "newLabOrder": "Order lab tests",
    "noVitals": "No vital signs recorded yet.",
    "noDiagnoses": "No diagnoses yet.",
    "noNotes": "No notes yet.",
    "noPrescriptions": "No prescriptions.",
    "noLabOrders": "No lab orders.",
    "closedBanner": "This encounter is {{status}} and read-only.",
    "start": "Start encounter",
    "empty": "No encounters found.",
    "soapTemplate": "S:\nO:\nA:\nP:"
  },
  "pharmacy": {
    "title": "Pharmacy",
    "worklist": "To dispense",
    "history": "History",
    "catalog": "Medication catalog",
    "prescription": "Prescription",
    "prescriptionNumber": "Prescription no.",
    "prescriber": "Prescriber",
    "issuedAt": "Issued",
    "items": "Items",
    "medication": "Medication",
    "selectMedication": "Search medication",
    "dose": "Dose",
    "doseUnit": "Unit",
    "frequency": "Frequency",
    "route": "Route",
    "duration": "Duration",
    "quantity": "Quantity",
    "instructions": "Instructions",
    "addItem": "Add medication",
    "removeItem": "Remove",
    "issue": "Sign & issue",
    "issued": "Prescription {{number}} issued",
    "dispense": "Dispense",
    "dispenseAll": "Dispense all remaining",
    "dispensed": "Medication dispensed",
    "dispensedQty": "Dispensed",
    "remaining": "Remaining",
    "cancelPrescription": "Cancel prescription",
    "allergyWarningTitle": "Allergy warning",
    "allergyWarningBody": "{{medication}} matches the documented allergy “{{allergen}}” ({{severity}}).",
    "overrideAndIssue": "Override and issue",
    "patientAllergies": "Patient allergies",
    "genericName": "Generic name",
    "brandName": "Brand name",
    "strength": "Strength",
    "dosageForm": "Dosage form",
    "unitPrice": "Unit price",
    "manufacturer": "Manufacturer",
    "newMedication": "New medication",
    "editMedication": "Edit medication",
    "empty": "No prescriptions waiting."
  },
  "lab": {
    "title": "Laboratory",
    "worklist": "Worklist",
    "completed": "Completed",
    "order": "Lab order",
    "orderNumber": "Order no.",
    "orderedBy": "Ordered by",
    "orderedAt": "Ordered",
    "priority": "Priority",
    "tests": "Tests",
    "selectTests": "Select tests",
    "clinicalNotes": "Clinical notes",
    "placeOrder": "Place order",
    "orderPlaced": "Lab order {{number}} placed",
    "collect": "Collect specimen",
    "collected": "Specimen collected",
    "specimen": "Specimen",
    "result": "Result",
    "value": "Value",
    "resultText": "Result text",
    "flag": "Flag",
    "unit": "Unit",
    "referenceRange": "Reference range",
    "saveResult": "Save result",
    "verify": "Verify",
    "verified": "Result verified",
    "correct": "Correct result",
    "correctionReason": "Correction reason",
    "corrected": "Result corrected",
    "enteredBy": "Entered by",
    "verifiedBy": "Verified by",
    "cancelOrder": "Cancel order",
    "empty": "No lab orders in this list.",
    "category": "Category",
    "price": "Price",
    "turnaround": "Turnaround",
    "awaitingResult": "Awaiting result"
  },
  "billing": {
    "title": "Billing",
    "invoices": "Invoices",
    "newInvoice": "New invoice",
    "invoice": "Invoice",
    "invoiceNumber": "Invoice no.",
    "patient": "Patient",
    "encounter": "Encounter",
    "items": "Items",
    "description": "Description",
    "quantity": "Qty",
    "unitPrice": "Unit price",
    "discount": "Discount",
    "tax": "Tax",
    "subtotal": "Subtotal",
    "total": "Total",
    "paid": "Paid",
    "balance": "Balance",
    "issuedAt": "Issued",
    "chargeItems": "Services & fees",
    "addCharge": "Add service",
    "unbilledItems": "Unbilled items from encounter",
    "includeUnbilled": "Include unbilled medications and lab tests",
    "payments": "Payments",
    "recordPayment": "Record payment",
    "amount": "Amount",
    "method": "Method",
    "provider": "Provider",
    "reference": "Reference",
    "paymentRecorded": "Payment recorded",
    "payInFull": "Pay full balance",
    "void": "Void invoice",
    "voidReason": "Reason for voiding",
    "refund": "Refund",
    "refundReason": "Reason for refund",
    "receipt": "Receipt",
    "printReceipt": "Print receipt",
    "created": "Invoice {{number}} created",
    "pendingConfirmation": "Awaiting provider confirmation",
    "outstanding": "Outstanding",
    "thankYou": "Thank you. Get well soon!",
    "selectEncounter": "Encounter (optional)",
    "empty": "No invoices found.",
    "receivedBy": "Received by",
    "applyDiscount": "Discount",
    "discountHint": "A discount is recorded with your name and the reason, and needs the discount permission.",
    "discountPreview": "Discount {{discount}} · new total {{total}}",
    "discountSaved": "Discount saved",
    "lineDiscounts": "Line discounts",
    "noDiscount": "no discount",
    "billDiscount": "Discount on the bill"
  },
  "admin": {
    "usersTitle": "Users",
    "newUser": "New user",
    "editUser": "Edit user",
    "username": "Username",
    "fullName": "Full name",
    "email": "Email",
    "phone": "Phone",
    "roles": "Roles",
    "password": "Initial password",
    "resetPassword": "Reset password",
    "newPassword": "New password",
    "disable": "Disable",
    "enable": "Enable",
    "lastLogin": "Last sign-in",
    "locked": "Locked",
    "userCreated": "User created",
    "isPractitioner": "This user is a clinical practitioner",
    "employeeCode": "Employee code",
    "specialty": "Specialty",
    "licenseNumber": "License number",
    "departmentsTitle": "Departments",
    "newDepartment": "New department",
    "departmentType": "Department type",
    "practitionersTitle": "Practitioners",
    "newPractitioner": "New practitioner",
    "displayName": "Display name",
    "department": "Department",
    "hospitalTitle": "Hospital settings",
    "hospitalName": "Hospital name",
    "registrationNumber": "Registration number",
    "timezone": "Time zone",
    "currency": "Currency",
    "defaultLanguage": "Default language",
    "organization": "Organization",
    "auditTitle": "Audit log",
    "auditAction": "Action",
    "auditResource": "Resource",
    "auditActor": "User",
    "auditTime": "Time",
    "auditIp": "IP address",
    "auditChanges": "Changes",
    "auditBefore": "Before",
    "auditAfter": "After",
    "auditResourceId": "Resource ID",
    "hospitalDetails": "Details",
    "hospitalLocation": "Location",
    "addressDetails": "Street, building and other details",
    "addressDetailsHint": "Printed on letterheads under the hospital name",
    "latitude": "Latitude",
    "longitude": "Longitude",
    "latitudeHint": "Between -90 and 90; enter both or neither",
    "longitudeHint": "Between -180 and 180; enter both or neither",
    "openMap": "Open in map",
    "clearPosition": "Clear position",
    "positionHint": "Decimal degrees, e.g. 17.966000 and 102.600000 for Vientiane. Use my location works on the device at the hospital.",
    "useMyLocation": "Use my location",
    "locateFailed": "Could not read this device's location",
    "hospitalPhoto": "Hospital photo and logo",
    "changePhoto": "Change photo",
    "uploadPhoto": "Upload photo",
    "removePhoto": "Remove photo",
    "photoHint": "JPEG, PNG or WebP. It is shown as the hospital logo in the menu, on the sign-in page and on printed forms. A square image works best.",
    "noPhotoYet": "No photo yet: the default HMS mark is shown as the logo.",
    "removePhotoMessage": "The default HMS mark will be shown as the logo again.",
    "photoSaved": "Hospital photo saved",
    "photoRemoved": "Hospital photo removed",
    "hospitalNameLo": "Hospital name (Lao)",
    "hospitalNameEn": "Hospital name (English)",
    "hospitalNameEnHint": "Shown when the interface is not in Lao and on printed forms"
  },
  "translations": {
    "title": "Translations",
    "subtitle": "Customize any text in the app. Changes apply immediately on web and mobile.",
    "locale": "Language",
    "scope": "Apply to",
    "scopeUSER": "Only me",
    "scopeHOSPITAL": "This hospital",
    "scopeGLOBAL": "All hospitals",
    "scopeHelpUSER": "Personal wording that only you will see.",
    "scopeHelpHOSPITAL": "Everyone at this hospital sees this wording.",
    "scopeHelpGLOBAL": "Default wording for every hospital (super administrators).",
    "key": "Key",
    "reference": "English reference",
    "baseValue": "Default text",
    "override": "Custom text",
    "effective": "Currently shown",
    "searchPlaceholder": "Search keys or text",
    "onlyCustomized": "Customized only",
    "onlyMissing": "Missing in this language",
    "resetKey": "Restore default",
    "resetAll": "Restore all defaults",
    "resetAllConfirm": "Remove every custom text in this language and scope?",
    "importDone": "{{count}} translations imported",
    "importInvalid": "The file is not a valid translation JSON file.",
    "saveAll": "Save changes",
    "unsaved": "{{count}} unsaved changes",
    "stats": "{{customized}} customized · {{total}} texts",
    "missing": "Missing",
    "inheritedFrom": "From: {{layer}}",
    "layerBundled": "Built-in",
    "saved": "Translations saved"
  },
  "languages": {
    "title": "Languages",
    "add": "Add language",
    "code": "Language code",
    "codeHelp": "ISO code, e.g. km or zh-Hant",
    "name": "English name",
    "nativeName": "Native name",
    "fallback": "Fallback language",
    "enabled": "Enabled",
    "builtin": "Built-in",
    "custom": "Custom",
    "added": "Language added. Translate it in Translations."
  },
  "settings": {
    "title": "Settings",
    "appearance": "Appearance",
    "theme": "Theme",
    "themeHelp": "Pick a color theme. “System” follows your device's light or dark mode.",
    "accent": "Accent color",
    "accentDefault": "Theme default",
    "density": "Density",
    "densityCompact": "Compact",
    "densityComfortable": "Comfortable",
    "language": "Language",
    "languageHelp": "Choose the language for menus and labels.",
    "account": "Account",
    "myTranslations": "My wording",
    "myTranslationsHelp": "Rename labels just for yourself — e.g. call “Encounters” “Visits”.",
    "savedOnServer": "Preferences are saved to your account and follow you to the mobile app."
  },
  "themes": {
    "system": "System",
    "clinical": "Clinical blue",
    "night": "Night",
    "ocean": "Ocean",
    "forest": "Forest",
    "lotus": "Lotus",
    "midnight": "Midnight",
    "contrast": "High contrast",
    "gold": "Gold",
    "oph": "OPH eye center"
  },
  "notifications": {
    "title": "Notifications",
    "empty": "You're all caught up.",
    "markAllRead": "Mark all as read",
    "unread": "{{count}} unread",
    "prescriptionIssued": "New prescription to dispense: {{ref}}",
    "labOrdered": "New lab order: {{ref}}",
    "labResultVerified": "Lab results ready: {{ref}}",
    "patientCheckedIn": "Patient checked in: {{ref}}",
    "highIop": "High eye pressure: {{ref}}",
    "eyeSurgeryScheduled": "Eye surgery scheduled: {{ref}}",
    "lowStock": "Low stock",
    "prSubmitted": "Purchase request to approve",
    "prApproved": "Your purchase request was approved",
    "prRejected": "Your purchase request was rejected",
    "poApproval": "Purchase order to approve",
    "stockDocSubmitted": "Stock document to check: {{ref}}",
    "patientAdmitted": "Patient admitted: {{ref}}",
    "patientDischarged": "Discharged, ready to bill: {{ref}}",
    "serviceOrdered": "New special service order: {{ref}}",
    "serviceReported": "Result to verify: {{ref}}",
    "serviceVerified": "Result ready: {{ref}}",
    "expenseSubmitted": "Expense to approve: {{ref}}",
    "cashSessionClosed": "Cash drawer to verify: {{ref}}",
    "posRefillSubmitted": "POS refill to prepare: {{ref}}",
    "posRefillSent": "POS refill on its way — confirm receipt: {{ref}}"
  },
  "time": {
    "justNow": "just now",
    "minutesAgo": "{{count}} min ago",
    "hoursAgo": "{{count}} h ago",
    "daysAgo": "{{count}} d ago"
  },
  "mobile": {
    "serverUrl": "Server address",
    "serverUrlHelp": "HMS server URL, e.g. https://hms.example.org or http://192.168.1.10:8090"
  },
  "months": {
    "1": "Jan",
    "2": "Feb",
    "3": "Mar",
    "4": "Apr",
    "5": "May",
    "6": "Jun",
    "7": "Jul",
    "8": "Aug",
    "9": "Sep",
    "10": "Oct",
    "11": "Nov",
    "12": "Dec"
  },
  "analytics": {
    "title": "Analytics",
    "year": "Year",
    "today": "Today",
    "periodYtd": "{{from}} – {{to}}, compared with the same period of {{prevYear}}",
    "periodFull": "Full year {{year}} compared with {{prevYear}}",
    "netRevenue": "Net revenue",
    "collected": "Collected",
    "collectionRate": "{{value}} collected",
    "visits": "Patient visits",
    "newPatients": "New patients",
    "revenuePerVisit": "Revenue per visit",
    "vsLastYear": "vs last year",
    "noPrevious": "No prior data",
    "revenueByCategory": "Revenue by service line",
    "paymentMethods": "Payments by method",
    "waterfall": "From charges to cash",
    "gross": "Gross charges",
    "discounts": "Discounts",
    "outstanding": "Outstanding",
    "net": "Net revenue",
    "revenueByMonth": "Net revenue by month",
    "revenueByQuarter": "Revenue by quarter",
    "revenueByMonthCategory": "Revenue by month and service line",
    "revenueByDepartment": "Revenue by department",
    "statement": "Income statement",
    "item": "Item",
    "change": "Change",
    "changePct": "Change %",
    "sectionRevenue": "Revenue",
    "totalGross": "Total gross revenue",
    "sectionOperations": "Operations",
    "invoices": "Invoices",
    "visitsByMonth": "Patient visits by month",
    "topDiagnoses": "Top diagnoses",
    "demographics": "Patients seen by age group and sex",
    "quarter": "Q{{n}}",
    "noData": "No data for this period",
    "category": {
      "CONSULTATION": "Consultation",
      "PHARMACY": "Pharmacy",
      "LABORATORY": "Laboratory",
      "PROCEDURE": "Procedures",
      "SERVICE": "Emergency & services",
      "ADMINISTRATIVE": "Administrative",
      "OTHER": "Other",
      "OPHTHALMOLOGY": "Eye center",
      "SPECIAL_SERVICES": "Special services",
      "INPATIENT": "Inpatient beds",
      "POS_SALES": "Counter sales"
    }
  },
  "eye": {
    "title": "Eye Center",
    "subtitle": "Ophthalmology: examinations, surgery, injections and follow-up",
    "overview": "Overview",
    "eyeRecord": "Eye record",
    "generalRecord": "General record",
    "openPatientRecord": "Open patient eye record",
    "patient": "Patient",
    "eyeSide": "Eye",
    "eyes": "Eyes",
    "side": {
      "OD": "Right eye (OD)",
      "OS": "Left eye (OS)",
      "OU": "Both eyes (OU)"
    },
    "examinations": "Examinations",
    "surgeries": "Surgeries",
    "injections": "Injections",
    "followUps": "Follow-ups",
    "medications": "Eye medications",
    "imaging": "Imaging",
    "procedures": "Procedures",
    "biometryIol": "Biometry & IOL",
    "trends": "Trends",
    "currentStatus": "Current status (latest per eye)",
    "newExam": "New eye exam",
    "startEyeExam": "Start eye exam",
    "openEyeExam": "Eye exam",
    "useOpenEncounter": "Continue in an open visit:",
    "startWithNewEncounter": "Start with a new visit",
    "planSurgery": "Plan surgery",
    "injection": "Injection",
    "followUp": "Follow-up",
    "recordInjection": "Record intravitreal injection",
    "prescribeDrops": "Prescribe eye drops",
    "scheduleFollowUp": "Schedule follow-up",
    "visualAcuity": "Visual acuity",
    "iop": "Eye pressure (IOP)",
    "refraction": "Refraction",
    "slitLamp": "Slit-lamp examination",
    "fundus": "Fundus examination",
    "diagnoses": "Eye diagnoses",
    "historyAndPlan": "History, notes and plan",
    "addVisualAcuity": "Record visual acuity",
    "addPressure": "Record eye pressure",
    "addRefraction": "Record refraction",
    "addDiagnosis": "Add eye diagnosis",
    "measurementType": "Measurement",
    "chartType": "Chart",
    "acuity": "Acuity",
    "acuityHint": "Snellen (6/12, 20/40), decimal, logMAR, CF, HM, LP, NLP",
    "correction": "Correction",
    "correctionPlaceholder": "e.g. spectacles, contact lens",
    "pressure": "Pressure",
    "method": "Method",
    "measuredAt": "Measured at",
    "refractionType": "Type",
    "sphere": "Sphere",
    "cylinder": "Cylinder",
    "axis": "Axis",
    "add": "Add",
    "pd": "PD",
    "acuityWithRx": "Acuity with this prescription",
    "vaType": {
      "UNAIDED": "Unaided",
      "CORRECTED": "With correction",
      "PINHOLE": "Pinhole",
      "BEST_CORRECTED": "Best corrected (BCVA)",
      "NEAR": "Near"
    },
    "chart": {
      "SNELLEN": "Snellen",
      "LOGMAR": "LogMAR",
      "DECIMAL": "Decimal",
      "TUMBLING_E": "Tumbling E",
      "LEA": "LEA symbols",
      "JAEGER": "Jaeger (near)",
      "OTHER": "Other"
    },
    "refractionTypes": {
      "AUTO": "Autorefraction",
      "RETINOSCOPY": "Retinoscopy",
      "SUBJECTIVE": "Subjective",
      "FINAL_PRESCRIPTION": "Final prescription"
    },
    "iopMethod": {
      "GOLDMANN": "Goldmann applanation",
      "NON_CONTACT": "Non-contact (air puff)",
      "TONOPEN": "Tono-Pen",
      "REBOUND": "Rebound (iCare)",
      "OTHER": "Other"
    },
    "iopLevel": {
      "LOW": "Low",
      "NORMAL": "Normal",
      "ELEVATED": "Elevated",
      "CRITICAL": "Critical"
    },
    "dxType": {
      "PRIMARY": "Primary",
      "SECONDARY": "Secondary",
      "DIFFERENTIAL": "Differential",
      "COMPLICATION": "Complication"
    },
    "severity": "Severity",
    "severities": {
      "MILD": "Mild",
      "MODERATE": "Moderate",
      "SEVERE": "Severe",
      "EARLY": "Early",
      "ADVANCED": "Advanced",
      "END_STAGE": "End stage",
      "NON_PROLIFERATIVE": "Non-proliferative",
      "PROLIFERATIVE": "Proliferative"
    },
    "icdCode": "ICD-10 code",
    "diagnosis": "Diagnosis",
    "dx": {
      "H25_1": "Age-related nuclear cataract",
      "H26_9": "Cataract, unspecified",
      "H40_1": "Primary open-angle glaucoma",
      "H40_2": "Primary angle-closure glaucoma",
      "E11_3": "Diabetic retinopathy",
      "H35_3": "Age-related macular degeneration",
      "H33_0": "Retinal detachment with break",
      "H34_8": "Retinal vein occlusion",
      "H10_0": "Acute bacterial conjunctivitis",
      "H16_0": "Corneal ulcer",
      "H11_0": "Pterygium",
      "H04_1": "Dry eye syndrome",
      "H52_1": "Myopia",
      "H52_0": "Hypermetropia",
      "H52_4": "Presbyopia",
      "H50_0": "Esotropia",
      "H53_0": "Amblyopia",
      "H20_0": "Acute anterior uveitis",
      "H00_0": "Hordeolum (stye)",
      "H57_1": "Eye pain"
    },
    "field": {
      "chiefComplaint": "Chief complaint",
      "historyOfPresentIllness": "History of present illness",
      "pastOcularHistory": "Past ocular history",
      "familyOcularHistory": "Family ocular history",
      "systemicHistory": "Systemic history",
      "clinicalNotes": "Clinical notes",
      "plan": "Plan",
      "lids": "Lids",
      "lashes": "Lashes",
      "conjunctiva": "Conjunctiva",
      "sclera": "Sclera",
      "cornea": "Cornea",
      "anteriorChamber": "Anterior chamber",
      "iris": "Iris",
      "pupil": "Pupil",
      "lens": "Lens",
      "vitreous": "Vitreous",
      "opticDisc": "Optic disc",
      "cupDiscRatio": "Cup/disc ratio",
      "macula": "Macula",
      "vessels": "Vessels",
      "retina": "Retina",
      "peripheralRetina": "Peripheral retina",
      "notes": "Notes"
    },
    "fillNormal": "Fill normal findings",
    "notRecorded": "Not recorded",
    "noDiagnoses": "No eye diagnoses yet",
    "cdrSuspicious": "C/D 0.6 or more is suspicious for glaucoma",
    "worse": "Worse",
    "better": "Better",
    "previousValue": "Previous: {{value}}",
    "sign": "Sign examination",
    "signConfirm": "Signing locks this examination. Later corrections are made as an amendment. Sign now?",
    "signed": "Examination signed",
    "amend": "Amend",
    "amendHelp": "A copy of the signed examination is created for correction; the original stays unchanged in the record.",
    "amendReason": "Reason for amendment",
    "amendmentOf": "This is an amendment of the",
    "originalExam": "original examination",
    "supersededBy": "This examination was amended. See the",
    "latestAmendment": "latest amendment",
    "signedBanner": "Signed by {{name}} on {{date}}",
    "comparedWith": "Compared with the previous examination of {{date}}",
    "cancelExam": "Cancel examination",
    "logmarHelp": "LogMAR: 0.0 = 6/6 (20/20), 0.3 = 6/12, 1.0 = 6/60. Lower is better; the axis is inverted so up means better.",
    "drivingStandard": "6/12 (driving standard)",
    "iopUpperNormal": "21 mmHg upper normal",
    "cstThreshold": "300 µm",
    "mdModerate": "−6 dB",
    "centralThickness": "Central subfield thickness",
    "rnfl": "RNFL thickness",
    "sphericalEquivalent": "Spherical equivalent",
    "visualField": "Visual field",
    "noTrendData": "No data yet",
    "treatments": "Treatments",
    "bcva": "Best corrected VA",
    "frequencies": {
      "qd": "Once daily",
      "bid": "Twice daily",
      "tid": "3 times daily",
      "qid": "4 times daily",
      "q2h": "Every 2 hours",
      "qhs": "Once nightly at bedtime"
    },
    "medication": "Medication",
    "medicationName": "Medication name",
    "otherMedication": "Other (type the name)",
    "dose": "Dose",
    "frequency": "Frequency",
    "duration": "Duration",
    "startDate": "Start date",
    "endDate": "End date",
    "instructions": "Instructions",
    "stop": "Stop",
    "stopMedication": "Stop eye medication",
    "noMedications": "No eye medications",
    "lotNumber": "Lot number",
    "expiryDate": "Expiry date",
    "indication": "Indication",
    "complications": "Complications",
    "confirmEyeStatement": "I confirmed the {{eye}} with the patient and the marked site, and checked the drug, dose and expiry.",
    "noInjections": "No injections recorded",
    "by": "By",
    "modality": "Modality",
    "results": "Results",
    "device": "Device",
    "noImaging": "No imaging studies",
    "modalities": {
      "FUNDUS_PHOTO": "Fundus photo",
      "OCT": "OCT",
      "OCT_ANGIOGRAPHY": "OCT angiography",
      "VISUAL_FIELD": "Visual field",
      "CORNEAL_TOPOGRAPHY": "Corneal topography",
      "PACHYMETRY": "Pachymetry",
      "B_SCAN": "B-scan ultrasound",
      "BIOMETRY": "Biometry",
      "OTHER": "Other"
    },
    "procedure": "Procedure",
    "outcome": "Outcome",
    "noExams": "No eye examinations",
    "noSurgeries": "No eye surgeries",
    "noFollowUps": "No follow-ups",
    "postOp": "Post-op review",
    "caseNumber": "Case no.",
    "biometry": "Biometry",
    "biometryHelp": "Optical biometry per eye. Select a measurement to plan the intraocular lens.",
    "addBiometry": "Add biometry",
    "noBiometry": "No biometry recorded",
    "axialLength": "Axial length",
    "lensThickness": "Lens thickness",
    "axialAsymmetry": "Axial lengths of the two eyes differ by {{diff}} mm. Re-measure before choosing a lens.",
    "toricHint": "Corneal astigmatism {{cyl}} D. Consider a toric IOL.",
    "formula": "Formula",
    "formulas": {
      "SRK_T": "SRK/T",
      "BARRETT_UNIVERSAL_II": "Barrett Universal II",
      "HAIGIS": "Haigis",
      "HOFFER_Q": "Hoffer Q",
      "HOLLADAY": "Holladay",
      "KANE": "Kane",
      "OTHER": "Other"
    },
    "aConstant": "A-constant",
    "targetRefraction": "Target refraction",
    "iolModel": "IOL model",
    "iolPower": "IOL power",
    "iolPowerAuto": "Leave empty to use the suggested power",
    "fromBiometer": "From the biometer printout",
    "predictedRefraction": "Predicted refraction",
    "saveCalculation": "Save calculation",
    "suggestedPower": "Suggested IOL power",
    "emmetropicPower": "Emmetropic power",
    "noCalculations": "No lens calculations yet",
    "selected": "Selected",
    "select": "Select",
    "iolSelected": "Lens selected for surgery",
    "operativeEye": "Operative eye",
    "surgeryType": "Surgery type",
    "surgeryTypes": {
      "CATARACT": "Cataract",
      "GLAUCOMA": "Glaucoma",
      "RETINA": "Retina",
      "VITRECTOMY": "Vitrectomy",
      "CORNEA": "Cornea",
      "REFRACTIVE": "Refractive",
      "OCULOPLASTIC": "Oculoplastic",
      "STRABISMUS": "Strabismus",
      "PTERYGIUM": "Pterygium",
      "LASER": "Laser",
      "OTHER": "Other"
    },
    "procedureExample": {
      "CATARACT": "Phacoemulsification + IOL",
      "GLAUCOMA": "Trabeculectomy",
      "RETINA": "Scleral buckle",
      "VITRECTOMY": "Pars plana vitrectomy",
      "CORNEA": "Penetrating keratoplasty",
      "REFRACTIVE": "LASIK",
      "OCULOPLASTIC": "Blepharoplasty",
      "STRABISMUS": "Medial rectus recession",
      "PTERYGIUM": "Excision with conjunctival autograft",
      "LASER": "YAG capsulotomy",
      "OTHER": "Describe the procedure"
    },
    "anesthesia": "Anesthesia",
    "anesthesiaTypes": {
      "TOPICAL": "Topical",
      "LOCAL": "Local",
      "PERIBULBAR": "Peribulbar block",
      "RETROBULBAR": "Retrobulbar block",
      "SUB_TENON": "Sub-Tenon block",
      "GENERAL": "General"
    },
    "scheduledAt": "Scheduled for",
    "preopDiagnosis": "Pre-operative diagnosis",
    "noBiometryForEye": "No biometry for this eye",
    "chooseEyeFirst": "Choose the eye first",
    "cataractNeedsBiometry": "Cataract surgery needs biometry and a selected lens for this eye before the pre-op checklist.",
    "safetyChecklist": "Pre-operative safety checklist",
    "checklistHelp": "Complete with the patient awake and the team present. The eye is stated by the team, not copied from the plan.",
    "teamStatesEye": "Eye stated by the team",
    "eyeMismatchTitle": "Wrong eye!",
    "eyeMismatchBody": "The plan is for the {{planned}} but the team stated the {{stated}}. Stop and verify.",
    "check": {
      "patientIdentityConfirmed": "Patient identity confirmed (name + date of birth)",
      "procedureConfirmed": "Procedure confirmed with patient and consent form",
      "eyeSideConfirmed": "Operative eye confirmed",
      "consentConfirmed": "Signed consent present",
      "siteMarked": "Operative site marked"
    },
    "confirmChecklist": "Confirm checklist",
    "checklistConfirmed": "Safety checklist confirmed",
    "confirmedBy": "Confirmed by {{name}} at {{date}}",
    "startSurgery": "Start surgery",
    "startConfirm": "Start {{procedure}} on the {{eye}}?",
    "cancelSurgery": "Cancel surgery",
    "cancelledBecause": "Cancelled: {{reason}}",
    "surgicalPlan": "Surgical plan",
    "surgeon": "Surgeon",
    "startedAt": "Started",
    "completedAt": "Completed",
    "lensPlan": "Lens plan",
    "openBiometry": "Open biometry",
    "noBiometryLinked": "No biometry linked",
    "selectedLens": "Selected lens",
    "noLensSelected": "No lens selected yet",
    "operativeRecord": "Operative record",
    "operativeFindings": "Operative findings",
    "operativeNotes": "Operative notes",
    "postopNotes": "Post-operative orders",
    "noneIfBlank": "Leave empty if none",
    "implants": "Implants",
    "implantTypes": {
      "IOL": "Intraocular lens",
      "CAPSULAR_TENSION_RING": "Capsular tension ring",
      "GLAUCOMA_DRAINAGE_DEVICE": "Glaucoma drainage device",
      "STENT": "Stent",
      "SILICONE_OIL": "Silicone oil",
      "GAS": "Gas tamponade",
      "OTHER": "Other"
    },
    "model": "Model",
    "manufacturer": "Manufacturer",
    "serialNumber": "Serial number",
    "powerMismatchTitle": "IOL power differs from the plan.",
    "powerMismatchBody": "The selected lens is {{planned}} D. Check the lens box against the plan.",
    "powerOverride": "I verified this power with the surgeon (documented override)",
    "firstPostOpVisit": "First post-op visit",
    "completeSurgery": "Complete surgery",
    "surgeryCompleted": "Surgery completed",
    "followUpDate": "Follow-up date",
    "inDays": "In {{count}} days",
    "examsToday": "Exams today",
    "openExams": "Open exams",
    "surgeriesUpcoming": "Upcoming surgeries",
    "surgeriesMonth": "Surgeries this month",
    "injectionsMonth": "Injections this month",
    "followUpsToday": "Follow-ups today",
    "followUpsOverdue": "Overdue follow-ups",
    "highIopPatients": "Patients with IOP over 21",
    "activityByMonth": "Eye clinic activity (last 12 complete months)",
    "activity": {
      "exams": "Examinations",
      "injections": "Injections",
      "surgeries": "Surgeries"
    },
    "surgeriesByType": "Surgeries by type (last 12 complete months)",
    "topEyeDiagnoses": "Top eye diagnoses (12 months)",
    "iopControl": "IOP control (latest per eye, 12 months)",
    "iopControlHelp": "Normal 10 to 21 mmHg. Elevated and critical eyes need review.",
    "cataractOutcome": "Cataract outcome",
    "cataractOutcomeHelp": "{{good}} of {{measured}} measured eyes reached 6/12 or better within 90 days ({{operated}} operations in 12 months).",
    "upcomingSurgeries": "Upcoming surgeries",
    "anyDate": "Any date",
    "myCases": "My cases",
    "due": {
      "overdue": "Overdue",
      "today": "Today",
      "week": "Next 7 days"
    },
    "phone": "Phone",
    "doctor": "Doctor",
    "markSeen": "Seen",
    "markMissed": "Missed"
  },
  "pathways": {
    "title": "Treatment cycles",
    "subtitle": "The care cycle of each disease, step by step, for doctors, nurses and patients",
    "cycles": "Cycles",
    "dueReviews": "Reviews due",
    "new": "New treatment cycle",
    "searchPlaceholder": "Search disease, code or cycle…",
    "categoryLabel": "Category",
    "category": {
      "EYE": "Eye",
      "CHRONIC": "Chronic disease",
      "INFECTIOUS": "Infectious disease",
      "MATERNAL": "Maternal & newborn",
      "SURGICAL": "Surgical",
      "PEDIATRIC": "Children",
      "MENTAL": "Mental health",
      "GENERAL": "General"
    },
    "shared": "Shared",
    "sharedTemplate": "Shared template",
    "sharedReadOnly": "This is a shared template. Copy it to your hospital to adapt the stages.",
    "hospital": "This hospital",
    "scope": "Scope",
    "cyclic": "Repeating cycle",
    "linear": "One-way pathway",
    "stageCount": "{{count}} stages",
    "activePatients": "{{count}} patients now",
    "disease": "Disease",
    "diseaseCode": "ICD-10 code",
    "stages": "Stages",
    "stage": "Stage",
    "patients": "Patients",
    "pathway": "Treatment cycle",
    "currentStage": "Current stage",
    "cycle": "Round",
    "cycleN": "Round {{n}}",
    "daysShort": "{{count}} d",
    "nextReview": "Next review",
    "nextReviewHint": "Leave empty to use the stage duration",
    "nextReviewOn": "Review {{date}}",
    "dueToday": "Today",
    "dueWeek": "7 days",
    "dueMonth": "30 days",
    "noneDue": "No reviews due",
    "details": "Details",
    "autoCode": "Generated if empty",
    "color": "Colour",
    "inherit": "Same as cycle",
    "isCyclicHelp": "Repeats: after the last stage the patient starts the next round",
    "translations": "Other languages",
    "addStage": "Add stage",
    "untitled": "Untitled",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "stageName": "Stage name",
    "durationDays": "Duration (days)",
    "icon": "Icon",
    "actions": "What the team does",
    "actionsHint": "Checklist for doctors and nurses at this stage",
    "patientInstructions": "Instructions for the patient",
    "patientInstructionsHint": "Shown in the patient app",
    "preview": "Preview",
    "previewCyclic": "Click a stage to edit it. The arrows show the repeating cycle.",
    "previewLinear": "Click a stage to edit it. The pathway ends after the last stage.",
    "copyToHospital": "Copy to my hospital",
    "copied": "Copied — you can now edit it",
    "archive": "Archive",
    "restore": "Restore",
    "archived": "Archived",
    "lastUpdated": "Updated {{date}} by {{name}}",
    "patientCycles": "Treatment cycles",
    "enroll": "Start a treatment cycle",
    "enrolled": "Treatment cycle started",
    "pickStartStage": "Click a stage to start there (default: first stage)",
    "noPlans": "No treatment cycles yet",
    "showEnded": "Show ended ({{count}})",
    "hideEnded": "Hide ended",
    "startedOn": "Started {{date}}",
    "since": "since {{date}}",
    "advance": "Next stage",
    "advanceTo": "Move the patient to",
    "startsCycle": "starts round {{n}}",
    "completesPlan": "This is the last stage: the treatment cycle will be completed.",
    "moveTo": "Move to stage",
    "addNote": "Note",
    "stop": "Stop cycle",
    "history": "History",
    "event": {
      "STARTED": "Started",
      "ADVANCED": "Next stage",
      "MOVED": "Moved",
      "NEW_CYCLE": "New round",
      "COMPLETED": "Completed",
      "STOPPED": "Stopped",
      "NOTE": "Note"
    }
  },
  "portal": {
    "cardTitle": "Patient app",
    "noAccount": "Not using the patient app yet.",
    "contact": "Phone / e-mail",
    "createdVia": "Signed up by",
    "via": {
      "SELF_REGISTRATION": "Self sign-up (new patient)",
      "SELF_LINKED": "Self sign-up (matched record)",
      "STAFF_ACTIVATION": "Activation code from the desk"
    },
    "lastLogin": "Last sign-in",
    "verifiedBy": "ID checked by",
    "pendingHelp": "Signed up from the app. Check an ID card, then press Verify identity.",
    "activeCode": "Unused activation code valid until {{date}}",
    "issueActivation": "Give app access",
    "newActivation": "New activation code",
    "verifyIdentity": "Verify identity",
    "verified": "Identity verified",
    "disable": "Disable app access",
    "enable": "Enable app access",
    "disableConfirm": "The patient is signed out on all phones and cannot sign in until access is enabled again.",
    "activationTitle": "Patient app activation",
    "activationFor": "Activation for",
    "activationExpires": "Valid until {{date}}",
    "step1": "Install the HMS app and choose \"I am a patient\".",
    "step2": "Tap \"Create account\", enter your phone or e-mail and this code.",
    "step3": "Enter the one-time code sent to you to finish.",
    "activationOnce": "The code is shown only once. Print it or let the patient scan it now.",
    "identifyTitle": "Identify patient by QR",
    "identifyHelp": "Ask the patient to open \"My health ID\" in the app and scan the QR code.",
    "pasteCode": "Or paste the code from a scanner",
    "identify": "Identify",
    "cameraUnavailable": "Camera not available. Use a scanner or paste the code.",
    "stopCamera": "Stop camera",
    "startCamera": "Start camera",
    "hasAllergies": "{{count}} active allergy record(s) — check before treatment.",
    "checkIdCard": "Signed up from the app: check the ID card before treatment.",
    "appointmentsToday": "Today's appointments",
    "checkedIn": "Checked in",
    "openRecord": "Open record",
    "giveTicket": "Give queue ticket",
    "scanAnother": "Scan another",
    "adminTitle": "Patient app",
    "adminSubtitle": "How patients get access, and messages sent by the demo gateway",
    "flowActivation": "Already registered at the hospital",
    "flowActivationText": "Open the patient and press \"Give app access\". The patient scans the QR (or types the code) in the app and confirms with a one-time code.",
    "flowSelf": "Sign up from the phone",
    "flowSelfText": "The patient enters phone or e-mail, name and date of birth and confirms an OTP. A matching record is linked; otherwise a new record waits for an ID check at the first visit.",
    "flowVisit": "Next visits",
    "flowVisitText": "The patient shows the QR health ID. Staff scan it in Patients or Queue to open the record, check in or give a ticket. Patients can also take a ticket in the app.",
    "dummyGateway": "Demo mode: SMS / e-mail and bank payments are simulated. One-time codes are recorded below (masked) and shown in the app; no money is charged.",
    "outbox": "Message outbox (simulated)",
    "outboxEmpty": "No messages yet",
    "destination": "To",
    "message": "Message",
    "msgStatus": {
      "SIMULATED": "Simulated"
    },
    "appStatus": {
      "VERIFIED": "App · verified",
      "PENDING_VERIFICATION": "App · ID check pending",
      "DISABLED": "App · disabled"
    },
    "appStatusHelp": {
      "VERIFIED": "Registered on the patient app; identity checked",
      "PENDING_VERIFICATION": "Signed up from the app; check the ID card at the next visit",
      "DISABLED": "Patient app access is disabled"
    },
    "appFilter": "Patient app",
    "appFilterRegistered": "Registered on the app",
    "appFilterNone": "Not registered on the app"
  },
  "patientApp": {
    "iAmPatient": "I am a patient",
    "iAmStaff": "Hospital staff",
    "welcome": "Your health, in your pocket",
    "welcomeSub": "See your visits, results and bills, get a queue ticket and show your health ID.",
    "signIn": "Sign in",
    "register": "Create account",
    "hospital": "Hospital",
    "usePhone": "Phone",
    "useEmail": "E-mail",
    "phone": "Mobile number",
    "email": "E-mail address",
    "sendCode": "Send code",
    "codeSentTo": "Enter the 6-digit code sent to {{destination}}",
    "code": "Verification code",
    "verify": "Confirm",
    "resend": "Send a new code",
    "demoCode": "Demo — your code is {{code}}",
    "loginHint": "If you have an account, a code will be sent to you.",
    "haveActivation": "I have an activation code from the hospital",
    "activationCode": "Activation code",
    "firstName": "First name",
    "lastName": "Last name",
    "dateOfBirth": "Date of birth",
    "sex": "Sex",
    "newHere": "New here? Create an account",
    "haveAccount": "Already have an account? Sign in",
    "pendingBanner": "Show your ID card at the registration desk on your first visit to unlock all features.",
    "home": "Home",
    "records": "Records",
    "queue": "Queue",
    "payments": "Payments",
    "profile": "Profile",
    "hello": "Hello, {{name}}",
    "myId": "My health ID",
    "idHelp": "Show this QR code at the hospital desk or the doctor.",
    "refreshesIn": "Refreshes in {{s}} s",
    "nextAppointment": "Next appointment",
    "noAppointment": "No upcoming appointments",
    "yourTicket": "Your queue ticket",
    "position": "Number {{n}} in line",
    "eta": "About {{min}} min",
    "calledNow": "It's your turn — {{counter}}",
    "takeTicket": "Get a queue ticket",
    "chooseDepartment": "Choose the department",
    "waitingCount": "{{count}} waiting",
    "noTicket": "No ticket today. Get one when you arrive at the hospital.",
    "visits": "Visits",
    "diagnoses": "Diagnoses",
    "prescriptions": "Medicines",
    "labResults": "Lab results",
    "eyeHealth": "Eye health",
    "treatmentCycles": "My treatment",
    "noRecords": "No visits yet",
    "outstanding": "To pay",
    "pay": "Pay",
    "choosePayment": "How do you want to pay?",
    "method": {
      "QR": "QR payment",
      "CARD": "Card",
      "BANK_TRANSFER": "Bank transfer",
      "MOBILE_MONEY": "Mobile money"
    },
    "dummyCheckout": "Demo payment — no money is charged. Choose the bank response to simulate.",
    "approve": "Simulate: bank approves",
    "decline": "Simulate: bank declines",
    "paymentApproved": "Payment completed. Thank you!",
    "paymentDeclined": "The payment was declined. Try again or pay at the cashier.",
    "bills": "Bills",
    "paymentHistory": "Payment history",
    "noInvoices": "No bills",
    "noPayments": "No payments yet",
    "balance": "Balance",
    "total": "Total",
    "notifications": "Messages",
    "noNotifications": "No messages",
    "notify": {
      "DIAGNOSIS": "Your doctor recorded a diagnosis ({{ref}})",
      "QUEUE_CALLED": "Your number {{ref}} is being called",
      "EncounterCompleted": "Visit {{ref}} summary is ready",
      "PrescriptionIssued": "New prescription {{ref}}",
      "LabResultVerified": "Lab result ready ({{ref}})",
      "InvoiceCreated": "New bill {{ref}}",
      "PaymentCompleted": "Payment {{ref}} received",
      "EyeExaminationSigned": "Your eye examination results are ready",
      "EyeSurgeryScheduled": "Eye surgery scheduled ({{ref}})",
      "AppointmentBooked": "Appointment booked ({{ref}})"
    },
    "allergies": "Allergies",
    "bloodGroup": "Blood group",
    "stageNow": "Now: {{stage}}",
    "instructions": "What to do",
    "signOut": "Sign out",
    "settings": "Language & theme",
    "verifiedAccount": "Identity verified",
    "pendingAccount": "ID check pending",
    "patientNumber": "Patient number",
    "continue": "Continue",
    "sexAge": "Sex · age",
    "address": "Address",
    "registeredOn": "Registered at the hospital",
    "myInformation": "My information",
    "infoHelp": "To correct your details, please ask the registration desk.",
    "outcome": {
      "ALREADY_REGISTERED": {
        "title": "You are already registered",
        "text": "This phone number or e-mail already has an account ({{mrn}}). You are now signed in to it."
      },
      "LINKED": {
        "title": "Account created",
        "text": "We found your hospital record {{mrn}} and linked it to your account. You can now see your visits, results and bills."
      },
      "CREATED": {
        "title": "Account created",
        "text": "Welcome! Your new patient number is {{mrn}}."
      },
      "ACTIVATED": {
        "title": "App activated",
        "text": "Your account is linked to your hospital record {{mrn}}."
      }
    },
    "appName": "HMS Patient"
  },
  "print": {
    "eyeCenterName": "Eye Treatment and Health Care Center",
    "eyeRegistration": "Print eye registration",
    "patientCode": "Patient code",
    "queueNo": "Queue no.",
    "fullName": "Name and surname",
    "dateOfBirth": "Date of birth",
    "sex": "Sex",
    "age": "Age",
    "years": "{{count}} years",
    "occupation": "Occupation",
    "disability": "Disabled patient",
    "village": "Village",
    "district": "District",
    "province": "Province",
    "phone": "Phone",
    "registeredOn": "Registration date",
    "registeredBy": "Registered by",
    "patientInfo": "Patient information",
    "newPatient": "New patient",
    "returningPatient": "Returning patient",
    "examDetails": "Examination details",
    "titleFemale": "Ms.",
    "titleMale": "Mr.",
    "downloadPdf": "Download PDF (A4)"
  },
  "reports": {
    "title": "Reports",
    "subtitle": "Run, print and export every report of the hospital",
    "catalog": "Report catalog",
    "total": "Total",
    "run": "Run report",
    "exportCsv": "Export CSV",
    "quickRange": "Quick range",
    "thisMonth": "This month",
    "lastMonth": "Last month",
    "thisYear": "This year",
    "pickReport": "Choose a report from the catalog",
    "pressRun": "Set the period and press “Run report”",
    "period": "Period",
    "rows": "Rows",
    "truncated": "Only the first 5,000 rows are shown; narrow the period to see everything.",
    "printedAt": "Printed",
    "noRows": "No data for this period",
    "category": {
      "PATIENTS": "Patients",
      "CLINICAL": "Clinical",
      "SERVICES": "Services",
      "FINANCE": "Finance",
      "OPERATIONS": "Operations",
      "EYE": "Eye center",
      "INVENTORY": "Drug & supply stock",
      "PROCUREMENT": "Procurement",
      "EQUIPMENT": "Medical equipment",
      "INPATIENT": "Inpatient",
      "SALES": "Pharmacy counter"
    },
    "r": {
      "patients-registered": {
        "title": "Registered patients",
        "desc": "Every patient registered in the period with address"
      },
      "patients-by-address": {
        "title": "Patients by address",
        "desc": "Patients per province and district"
      },
      "demographics": {
        "title": "Demographics",
        "desc": "Visiting patients by age group and sex"
      },
      "appointments": {
        "title": "Appointments",
        "desc": "All appointments scheduled in the period"
      },
      "visits-by-department": {
        "title": "Visits by department",
        "desc": "Daily visits per department and type"
      },
      "visits": {
        "title": "Visit register",
        "desc": "Every encounter with diagnoses"
      },
      "morbidity": {
        "title": "Morbidity (ICD-10)",
        "desc": "Diagnosed cases by code, sex and age band"
      },
      "medications": {
        "title": "Medication usage",
        "desc": "Prescribed and dispensed quantities per medication"
      },
      "laboratory": {
        "title": "Laboratory workload",
        "desc": "Tests ordered, verified and abnormal"
      },
      "revenue-daily": {
        "title": "Daily revenue",
        "desc": "Invoiced, discounted and collected per day"
      },
      "revenue-by-service": {
        "title": "Revenue by service",
        "desc": "Billed amount per service category"
      },
      "payments": {
        "title": "Payments received",
        "desc": "Every payment with method and cashier"
      },
      "outstanding": {
        "title": "Outstanding balances",
        "desc": "Unpaid invoices with ageing"
      },
      "queue-performance": {
        "title": "Queue performance",
        "desc": "Tickets, waiting and service times"
      },
      "care-plans": {
        "title": "Treatment cycles",
        "desc": "Patients per pathway and stage"
      },
      "patient-app": {
        "title": "Patient app usage",
        "desc": "Accounts, activations, tickets and payments"
      },
      "staff-activity": {
        "title": "Staff activity",
        "desc": "Actions recorded per staff member"
      },
      "eye-exams": {
        "title": "Eye examinations",
        "desc": "Exams with VA, IOP and diagnoses"
      },
      "eye-surgeries": {
        "title": "Eye surgeries",
        "desc": "Operations with surgeon, IOL and outcome"
      },
      "eye-injections": {
        "title": "Intravitreal injections",
        "desc": "Injections with medication and lot"
      },
      "eye-high-iop": {
        "title": "High eye pressure",
        "desc": "Latest IOP above 21 mmHg"
      },
      "eye-follow-ups": {
        "title": "Eye follow-ups",
        "desc": "Scheduled and overdue eye reviews"
      },
      "inventory-stock": {
        "title": "Stock on hand",
        "desc": "Quantity, cost and value per item and store"
      },
      "inventory-low-stock": {
        "title": "Low stock & reorder",
        "desc": "Items at or below the reorder level with suggested order quantities"
      },
      "inventory-expiry": {
        "title": "Expiry report",
        "desc": "Lots expired or expiring up to the end date"
      },
      "inventory-movements": {
        "title": "Stock ledger",
        "desc": "Every stock movement in the period"
      },
      "inventory-consumption": {
        "title": "Consumption by item",
        "desc": "Dispensed and issued quantities, value and days of cover"
      },
      "inventory-consumption-department": {
        "title": "Consumption by department",
        "desc": "Value used by prescriptions and by each department"
      },
      "inventory-valuation": {
        "title": "Stock valuation",
        "desc": "Stock value by type and category"
      },
      "inventory-adjustments": {
        "title": "Adjustments & write-offs",
        "desc": "Opening balances, corrections, write-offs and returns"
      },
      "inventory-abc": {
        "title": "ABC analysis",
        "desc": "Items ranked by consumption value (A = top 80%)"
      },
      "purchase-requests": {
        "title": "Purchase requests",
        "desc": "Requests created in the period with status and value"
      },
      "purchase-orders": {
        "title": "Purchase orders",
        "desc": "Orders placed in the period, received and outstanding value"
      },
      "goods-receipts": {
        "title": "Goods received",
        "desc": "Every received line with lot, expiry and cost"
      },
      "supplier-performance": {
        "title": "Supplier performance",
        "desc": "Order value, on-time delivery and lead time per supplier"
      },
      "equipment-register": {
        "title": "Equipment register",
        "desc": "All medical equipment with location, warranty and maintenance"
      },
      "equipment-maintenance": {
        "title": "Maintenance log",
        "desc": "Maintenance, calibration and repairs in the period"
      },
      "equipment-due": {
        "title": "Maintenance due",
        "desc": "Equipment due or overdue for maintenance by the end date"
      },
      "ipd-census": {
        "title": "Patients in the ward now",
        "desc": "Every admitted patient with bed, days and expected discharge"
      },
      "ipd-admissions": {
        "title": "Admissions",
        "desc": "Admissions in the period with type, ward and outcome"
      },
      "ipd-discharges": {
        "title": "Discharges",
        "desc": "Patients discharged in the period, length of stay and follow-up"
      },
      "ipd-occupancy": {
        "title": "Bed occupancy",
        "desc": "Beds per ward, bed-days used and occupancy rate"
      },
      "ipd-length-of-stay": {
        "title": "Length of stay",
        "desc": "Average, shortest and longest stay per ward and how patients left"
      },
      "special-services": {
        "title": "Special services",
        "desc": "Every X-ray, ultrasound, ECG ... ordered, with status and turnaround"
      },
      "special-services-summary": {
        "title": "Special services by service",
        "desc": "Orders, completed, pending and revenue per service"
      },
      "sales-daily": {
        "title": "Counter sales by day",
        "desc": "Sales, discounts, refunds, cash and margin per day"
      },
      "sales-items": {
        "title": "Best-selling items",
        "desc": "Quantity sold, returns, revenue, cost and margin per item"
      },
      "sales-transactions": {
        "title": "Sales receipts",
        "desc": "Every counter sale with cashier, payment and returns"
      },
      "finance-profit-loss": {
        "title": "Profit and loss",
        "desc": "Revenue, cost of goods, expenses and net profit"
      },
      "finance-revenue-sources": {
        "title": "Revenue by source",
        "desc": "Bills by department and counter sales"
      },
      "finance-discounts": {
        "title": "Discounts given",
        "desc": "Every discount on bills and at the counter with the reason"
      },
      "finance-expenses": {
        "title": "Expenses",
        "desc": "Expenses with who recorded and who approved them"
      },
      "finance-cash-sessions": {
        "title": "Cash drawers",
        "desc": "Expected and counted cash, differences and verification"
      },
      "finance-price-list": {
        "title": "Price list",
        "desc": "Every fee, drug, test, service, bed rate and item for sale"
      },
      "finance-price-changes": {
        "title": "Price changes",
        "desc": "Old and new price, reason and who changed it"
      },
      "stock-documents": {
        "title": "Stock documents",
        "desc": "Stock in, stock out and transfers with maker and checker"
      },
      "morbidity-by-type": {
        "title": "Morbidity by disease type",
        "desc": "Diagnosed cases grouped by the disease catalog types, with notifiable cases, sex and age band"
      }
    },
    "col": {
      "abnormal": "Abnormal",
      "abnormalRate": "Abnormal %",
      "actions": "Actions",
      "activationCodes": "Activation codes",
      "activePatients": "Active patients",
      "administeredBy": "Given by",
      "age": "Age",
      "age15to49": "15–49",
      "age50plus": "50+",
      "age5to14": "5–14",
      "ageGroup": "Age group",
      "ageing": "Ageing",
      "amount": "Amount",
      "appPaid": "Paid in app",
      "appPayments": "App payments",
      "appTickets": "App tickets",
      "appointmentNumber": "Appointment no.",
      "avgServiceMinutes": "Avg service (min)",
      "avgTurnaroundMinutes": "Avg turnaround (min)",
      "avgWaitMinutes": "Avg wait (min)",
      "balance": "Balance",
      "caseNumber": "Case no.",
      "cases": "Cases",
      "category": "Category",
      "code": "Code",
      "collected": "Collected",
      "completedInRange": "Completed",
      "complications": "Complications",
      "creates": "Created",
      "date": "Date",
      "dateOfBirth": "Date of birth",
      "daysOverdue": "Days overdue",
      "department": "Department",
      "diagnoses": "Diagnoses",
      "diagnosis": "Diagnosis",
      "discount": "Discount",
      "district": "District",
      "doctor": "Doctor",
      "emergency": "Emergency",
      "encounterNumber": "Visit no.",
      "examinedBy": "Examined by",
      "eye": "Eye",
      "female": "Female",
      "form": "Form",
      "fromApp": "From app",
      "gross": "Gross",
      "indication": "Indication",
      "invoiceNumber": "Invoice no.",
      "invoices": "Invoices",
      "iol": "IOL",
      "iop": "IOP (mmHg)",
      "iopOd": "IOP OD",
      "iopOs": "IOP OS",
      "issuedAt": "Issued",
      "lastActivity": "Last activity",
      "lines": "Lines",
      "lotNumber": "Lot no.",
      "male": "Male",
      "maxWaitMinutes": "Max wait (min)",
      "measuredAt": "Measured",
      "medication": "Medication",
      "method": "Method",
      "mrn": "Patient code",
      "net": "Net",
      "newAccounts": "New accounts",
      "newInRange": "New in period",
      "newPatients": "New patients",
      "nextFollowUp": "Next follow-up",
      "opd": "OPD",
      "ordered": "Ordered",
      "other": "Other",
      "outstanding": "Outstanding",
      "overdueReviews": "Overdue reviews",
      "paidAt": "Paid at",
      "pathway": "Pathway",
      "patientName": "Patient",
      "patients": "Patients",
      "paymentNumber": "Payment no.",
      "phone": "Phone",
      "postOpVa": "Post-op VA",
      "practitioner": "Practitioner",
      "prescriptions": "Prescriptions",
      "procedureName": "Procedure",
      "province": "Province",
      "quantity": "Quantity",
      "quantityDispensed": "Dispensed",
      "quantityPrescribed": "Prescribed",
      "reason": "Reason",
      "receivedBy": "Received by",
      "registeredAt": "Registered",
      "registeredBy": "Registered by",
      "scheduledStart": "Scheduled",
      "selfRegistered": "Self-registered",
      "served": "Served",
      "sex": "Sex",
      "share": "Share",
      "signatures": "Signatures",
      "skipped": "Skipped",
      "staff": "Staff",
      "stage": "Stage",
      "startedAt": "Started",
      "startedInRange": "Started in period",
      "status": "Status",
      "surgeon": "Surgeon",
      "test": "Test",
      "tickets": "Tickets",
      "total": "Total",
      "type": "Type",
      "under5": "Under 5",
      "updates": "Updated",
      "vaOd": "VA OD",
      "vaOs": "VA OS",
      "value": "Value",
      "verified": "Verified",
      "views": "Views",
      "village": "Village",
      "itemCode": "Item code",
      "item": "Item",
      "itemType": "Type",
      "store": "Store",
      "unit": "Unit",
      "onHand": "On hand",
      "usable": "Usable",
      "unitCost": "Unit cost",
      "stockValue": "Stock value",
      "reorderLevel": "Reorder level",
      "nextExpiry": "Next expiry",
      "onOrder": "On order",
      "avgDailyUse": "Avg / day",
      "daysOfCover": "Days of cover",
      "suggestedQuantity": "Suggested order",
      "estimatedCost": "Estimated cost",
      "expiryDate": "Expiry date",
      "daysLeft": "Days left",
      "expiryStatus": "Expiry",
      "performedAt": "Date / time",
      "movementType": "Movement",
      "balanceAfter": "Balance",
      "reference": "Reference",
      "performedBy": "By",
      "dispensed": "Dispensed",
      "issued": "Issued",
      "totalUsed": "Total used",
      "items": "Items",
      "expiredValue": "Expired value",
      "abcClass": "ABC class",
      "cumulativeShare": "Cumulative share",
      "prNumber": "PR no.",
      "createdAt": "Created",
      "requestedBy": "Requested by",
      "priority": "Priority",
      "estimatedTotal": "Estimated total",
      "decidedBy": "Decided by",
      "decidedAt": "Decided",
      "orders": "Orders",
      "poNumber": "PO no.",
      "orderDate": "Order date",
      "supplier": "Supplier",
      "expectedDate": "Expected",
      "receivedValue": "Received value",
      "outstandingValue": "Outstanding value",
      "approvedBy": "Approved by",
      "receivedAt": "Received",
      "grnNumber": "GRN no.",
      "orderedValue": "Ordered value",
      "onTimeRate": "On time",
      "avgLeadDays": "Avg lead (days)",
      "lateOrders": "Late orders",
      "assetTag": "Asset tag",
      "serialNumber": "Serial no.",
      "model": "Model",
      "location": "Location",
      "purchaseDate": "Purchased",
      "purchaseCost": "Purchase cost",
      "warrantyExpiry": "Warranty until",
      "nextMaintenance": "Next maintenance",
      "maintenanceStatus": "Maintenance",
      "eventType": "Event",
      "cost": "Cost",
      "statusAfter": "Status after",
      "nextDueDate": "Next due",
      "notes": "Notes",
      "dueDate": "Due date",
      "admissionNumber": "Admission",
      "admissionType": "Type",
      "admissions": "Admissions",
      "admittedAt": "Admitted",
      "againstAdvice": "Against advice",
      "attending": "Attending doctor",
      "available": "Free",
      "averageDays": "Average days",
      "bed": "Bed",
      "bedDays": "Bed-days",
      "beds": "Beds",
      "cancelled": "Cancelled",
      "cash": "Cash",
      "cashier": "Cashier",
      "changeRate": "Change %",
      "changedAt": "Changed",
      "changedBy": "Changed by",
      "checkedAt": "Checked",
      "checkedBy": "Checked by",
      "cleaning": "Cleaning",
      "closedAt": "Closed",
      "completed": "Completed",
      "countedCash": "Counted",
      "customer": "Customer",
      "days": "Days",
      "deceased": "Deceased",
      "description": "Description",
      "destination": "To",
      "dischargeType": "Discharged to",
      "dischargedAt": "Discharged",
      "dischargedBy": "Discharged by",
      "discharges": "Discharges",
      "discountType": "By",
      "discountValue": "Value",
      "docNumber": "Document",
      "docType": "Type",
      "entityType": "Type",
      "expectedCash": "Expected",
      "expectedDischarge": "Expected out",
      "expenseDate": "Date",
      "expenseNumber": "Expense",
      "followUpDate": "Follow-up",
      "home": "Home",
      "line": "Line",
      "margin": "Margin",
      "marginRate": "Margin %",
      "maxDays": "Longest",
      "minDays": "Shortest",
      "name": "Name",
      "newPrice": "New price",
      "nonCash": "Non-cash",
      "occupancyRate": "Occupancy %",
      "occupied": "Occupied",
      "oldPrice": "Old price",
      "openedAt": "Opened",
      "openingFloat": "Opening float",
      "orderNumber": "Order",
      "orderedAt": "Ordered",
      "outOfService": "Out of service",
      "payee": "Paid to",
      "paymentMethod": "Payment",
      "pending": "Pending",
      "preparedBy": "Prepared by",
      "price": "Price",
      "recordedBy": "Recorded by",
      "referred": "Referred",
      "refunded": "Refunded",
      "refunds": "Refunds",
      "reportedBy": "Reported by",
      "returned": "Returned",
      "revenue": "Revenue",
      "saleNumber": "Sale",
      "sales": "Sales",
      "section": "Section",
      "service": "Service",
      "sessionNumber": "Drawer",
      "sold": "Sold",
      "soldAt": "Sold",
      "source": "Source",
      "turnaroundMinutes": "Turnaround (min)",
      "variance": "Difference",
      "verifiedBy": "Verified by",
      "ward": "Ward",
      "diseaseType": "Disease type",
      "notifiableCases": "Notifiable cases"
    },
    "from": "From",
    "to": "To"
  },
  "locations": {
    "title": "Locations",
    "subtitle": "Provinces, districts, subdistricts and villages of Lao PDR",
    "counts": "{{provinces}} provinces · {{districts}} districts · {{villages}} villages",
    "pickDistrict": "Choose a district to manage its subdistricts and villages",
    "addSubdistrict": "Add subdistrict",
    "editSubdistrict": "Edit subdistrict",
    "noSubdistricts": "No subdistricts yet. Add one and assign villages to it.",
    "villageCount": "{{count}} villages",
    "assignVillages": "Assign villages",
    "searchVillage": "Search village",
    "nameLa": "Name (Lao)",
    "nameEn": "Name (English)",
    "inOtherSubdistrict": "in {{name}}"
  },
  "inventory": {
    "title": "Drug, pharmacy & equipment inventory",
    "subtitle": "Stock, lots and expiry, purchase requests and orders, suppliers and medical equipment",
    "item": "Item",
    "items": "Items",
    "name": "Name",
    "itemType": "Type",
    "category": "Category",
    "unit": "Unit",
    "manufacturer": "Manufacturer",
    "unitCost": "Unit cost",
    "unitCostShort": "Cost {{value}} / unit",
    "reorderLevel": "Reorder level",
    "reorderLevelHint": "Warn and suggest an order when usable stock falls to this level",
    "reorderQuantity": "Reorder quantity",
    "maxLevel": "Maximum level",
    "maxLevelHint": "Above this the item counts as overstocked",
    "maxShort": "Max {{value}}",
    "trackExpiry": "Track lot and expiry date",
    "controlled": "Controlled drug",
    "controlledShort": "Controlled",
    "storageCondition": "Storage condition",
    "linkMedication": "Medication (pharmacy catalog)",
    "linkMedicationHint": "Linked drugs are taken from stock when prescriptions are dispensed",
    "noMedicationLink": "Not linked (not dispensed on prescriptions)",
    "fromMedication": "From the medication",
    "newItem": "New item",
    "editItem": "Edit item",
    "searchItem": "Search drug, supply or equipment…",
    "noItems": "No items found",
    "usable": "Usable stock",
    "onHand": "On hand",
    "onOrder": "On order",
    "stockValue": "Stock value",
    "stockStatus": "Stock status",
    "daysOfCover": "Days of cover",
    "days": "{{count}} days",
    "daysLeft": "{{count}} days left",
    "expiredAgo": "Expired {{count}} days ago",
    "overdueDays": "{{count}} days overdue",
    "nextExpiry": "Next expiry",
    "assetsCount": "{{count}} devices",
    "allStores": "All stores",
    "allSuppliers": "All suppliers",
    "store": "Store",
    "storeType": "Store type",
    "newStore": "New store",
    "editStore": "Edit store",
    "dispensing": "Dispensing",
    "dispensingStore": "Prescriptions are dispensed from this store",
    "dispensingStoreHint": "Stock of linked drugs is reduced here when the pharmacy dispenses.",
    "fromStore": "From store",
    "toStore": "To store",
    "toDepartment": "To department",
    "department": "Department",
    "deliverTo": "Deliver to",
    "supplier": "Supplier",
    "newSupplier": "New supplier",
    "editSupplier": "Edit supplier",
    "noSuppliers": "No suppliers yet",
    "contact": "Contact",
    "contactPerson": "Contact person",
    "phone": "Phone",
    "email": "E-mail",
    "address": "Address",
    "taxId": "Tax ID",
    "paymentTerms": "Payment terms",
    "leadTimeDays": "Lead time (days)",
    "leadDays": "delivers in {{count}} days",
    "orders": "Orders",
    "receivedValueShort": "Received value",
    "lots": "Lots",
    "lotNumber": "Lot number",
    "expiryDate": "Expiry date",
    "noLots": "No stock lots",
    "lotsAndExpiry": "Lots & expiry",
    "ledger": "Stock ledger",
    "allLots": "All lots",
    "expiredOnly": "Expired",
    "within": "≤ {{count}} days",
    "lotsTotal": "{{count}} lots · {{value}}",
    "lotsCount": "{{count}} lots",
    "lotSummary": "Lot {{lot}} in {{store}}: {{quantity}}",
    "receivedAt": "Received",
    "movementType": "Movement",
    "quantity": "Quantity",
    "balanceAfter": "Balance",
    "reference": "Reference",
    "performedAt": "Date / time",
    "performedBy": "By",
    "noMovements": "No stock movements",
    "recentMovements": "Recent movements",
    "clearItemFilter": "Show all items",
    "byStore": "Stock by store",
    "usageByMonth": "Received and used per month",
    "avgDailyUse": "Average daily use",
    "coverDays": "Lasts about {{count}} days",
    "noUse": "No use in the last 90 days",
    "expiredQty": "Expired stock",
    "equipmentHint": "Equipment is tracked per device ({{count}} registered).",
    "openEquipment": "Open equipment register",
    "addStock": "Add stock",
    "stockAdded": "Stock added",
    "adjustmentType": "Type",
    "reason": "Reason",
    "removeFromLot": "Remove",
    "stockRemoved": "Stock removed",
    "issue": "Issue",
    "issueStock": "Issue to department",
    "issued": "Issued {{number}}",
    "transfer": "Transfer",
    "transferStock": "Transfer between stores",
    "transferred": "Transferred {{number}}",
    "fefoHint": "Stock is taken from the lot that expires first (FEFO).",
    "requestPurchase": "Request purchase",
    "warnings": "Warnings",
    "noWarnings": "No warnings — stock, expiry and equipment are in order",
    "seeAll": "See all",
    "uncategorized": "Uncategorized",
    "updatedAt": "Updated {{time}}",
    "requestOnlyHint": "You can create purchase requests from the Purchase requests tab.",
    "purchaseRequest": "Purchase request",
    "purchaseOrder": "Purchase order",
    "prNumber": "PR no.",
    "poNumber": "PO no.",
    "newRequest": "New purchase request",
    "editRequest": "Edit purchase request {{number}}",
    "newOrder": "New purchase order",
    "editOrder": "Edit purchase order {{number}}",
    "noRequests": "No purchase requests",
    "noOrders": "No purchase orders",
    "mineOnly": "My requests only",
    "createdAt": "Created",
    "created": "Created",
    "requestedBy": "Requested by",
    "requestedByOn": "Requested by {{name}} on {{date}}",
    "requestingDepartment": "Requesting department",
    "priority": "Priority",
    "neededBy": "Needed by",
    "reasonForRequest": "Reason / justification",
    "estimatedUnitCost": "Estimated unit cost",
    "estimatedTotal": "Estimated total",
    "lineTotal": "Line total",
    "saveDraft": "Save draft",
    "saveAndSubmit": "Save and submit for approval",
    "submit": "Submit for approval",
    "approve": "Approve",
    "reject": "Reject",
    "approveRequest": "Approve {{number}}",
    "rejectRequest": "Reject {{number}}",
    "approveHint": "Approve the quantity per line; 0 removes a line.",
    "requested": "Requested",
    "approvedQty": "Approved",
    "decisionNote": "Decision note",
    "cancelRequest": "Cancel request",
    "cancelRequestConfirm": "The request is cancelled and can no longer be ordered.",
    "selfApprovalHint": "You submitted this request, so another approver must decide on it.",
    "selfApprovalPoHint": "You prepared this order, so another approver must approve it.",
    "awaitingApproval": "Waiting for approval by a procurement approver.",
    "prSubmitted": "Purchase request submitted for approval",
    "prApproved": "Purchase request approved",
    "prRejected": "Purchase request rejected",
    "prCancelled": "Purchase request cancelled",
    "createPo": "Create purchase order",
    "poCreated": "Purchase order {{number}} created",
    "history": "History",
    "details": "Details",
    "reorderSuggestions": "Reorder suggestions",
    "suggestionsHint": "Items at or below their reorder level, net of quantities already on order. Suggested quantity fills up to the maximum level.",
    "noSuggestions": "Nothing needs reordering right now",
    "createPrFromSelection": "Create request ({{count}} items)",
    "reorderReason": "Replenishment of items at or below the reorder level",
    "orderDate": "Order date",
    "orderedOn": "ordered on {{date}}",
    "expectedDate": "Expected delivery",
    "expectedDateHint": "Empty: today + the supplier's lead time",
    "overdue": "Overdue",
    "total": "Total",
    "ordered": "Ordered",
    "received": "Received",
    "receivedValue": "received {{value}}",
    "outstanding": "Outstanding",
    "saveOrder": "Save purchase order",
    "markSent": "Mark as sent to supplier",
    "receive": "Receive goods",
    "receiveGoods": "Receive goods — {{number}}",
    "receiveHint": "Enter what arrived. Drugs and other dated items need a lot number and expiry date; expired goods cannot be received.",
    "receiveQty": "Receive now",
    "required": "Required",
    "deliveryNote": "Delivery note no.",
    "confirmReceipt": "Confirm receipt",
    "goodsReceived": "Goods received into stock",
    "goodsReceipts": "Goods receipts",
    "noReceipts": "Nothing received yet",
    "closeShort": "Close (rest not coming)",
    "closeShortConfirm": "The order is closed with the quantities received so far.",
    "cancelOrder": "Cancel order",
    "poApproved": "Purchase order approved",
    "poSent": "Purchase order marked as sent",
    "poCancelled": "Purchase order cancelled",
    "poClosed": "Purchase order closed",
    "preparedBy": "Prepared by",
    "approvedBy": "Approved by",
    "supplierAcknowledgement": "Supplier acknowledgement",
    "description": "Description",
    "equipment": "Equipment",
    "newAsset": "Register equipment",
    "editAsset": "Edit equipment",
    "noAssets": "No equipment registered",
    "equipmentType": "Equipment type",
    "equipmentTypeHint": "An inventory item of type Equipment (create it in Items first).",
    "searchEquipment": "Search equipment, tag, serial or location…",
    "assetTag": "Asset tag",
    "assetTagHint": "Empty: numbered automatically",
    "serialNumber": "Serial number",
    "model": "Model",
    "location": "Location",
    "purchaseDate": "Purchase date",
    "purchaseCost": "Purchase cost",
    "purchasedFor": "bought for {{value}} on {{date}}",
    "warrantyExpiry": "Warranty until",
    "underWarranty": "Under warranty",
    "warrantyEnded": "Warranty ended",
    "maintenanceInterval": "Maintenance every (days)",
    "lastMaintenance": "Last maintenance",
    "lastOn": "last on {{date}}",
    "nextMaintenance": "Next maintenance",
    "nextMaintenanceHint": "Empty: last maintenance + interval",
    "maintenanceDueOnly": "Maintenance due",
    "maintenanceCost": "Maintenance cost",
    "serviceHistory": "Maintenance & service history",
    "noEvents": "No maintenance recorded",
    "logEvent": "Log service event — {{tag}}",
    "logEventShort": "Log maintenance",
    "eventType": "Event",
    "eventDate": "Date",
    "cost": "Cost",
    "statusAfter": "Status after",
    "noChange": "No change",
    "nextDueDate": "Next due",
    "nextDueHint": "Empty: today + maintenance interval",
    "recordedBy": "Recorded by",
    "tab": {
      "dashboard": "Statistics",
      "items": "Items",
      "stock": "Stock",
      "requests": "Purchase requests",
      "orders": "Purchase orders",
      "suppliers": "Suppliers",
      "equipment": "Equipment",
      "alerts": "Warnings",
      "stores": "Stores",
      "stockIn": "Stock in",
      "stockOut": "Stock out",
      "transfers": "Transfers",
      "toCheck": "To check",
      "posRefills": "POS refill requests"
    },
    "kpi": {
      "stockValue": "Stock value",
      "itemsCount": "{{count}} active items",
      "outOfStock": "Out of stock",
      "lowCount": "{{count}} low",
      "lowStock": "Low stock",
      "overCount": "{{count}} overstocked",
      "expiring30": "Expiring ≤ 30 days",
      "expiredLots": "{{count}} expired lots · {{value}}",
      "prPending": "Requests to approve",
      "prApproved": "{{count}} approved, not yet ordered",
      "poOpen": "Open purchase orders",
      "poOverdue": "{{count}} overdue · {{value}} outstanding",
      "equipment": "Medical equipment",
      "maintenance": "{{due}} due · {{overdue}} overdue"
    },
    "chart": {
      "flowByMonth": "Received, used and written off per month",
      "received": "Received",
      "consumed": "Used",
      "writtenOff": "Written off",
      "valueByCategory": "Stock value by category",
      "topConsumed": "Most used (90 days, by value)",
      "expiryTimeline": "Stock value expiring per month",
      "expiringValue": "Expiring",
      "spendBySupplier": "Purchases by supplier (12 months)"
    },
    "severity": {
      "danger": "{{count}} urgent",
      "warning": "{{count}} warnings",
      "info": "{{count}} for information"
    },
    "alert": {
      "OUT_OF_STOCK": "Out of stock",
      "LOW_STOCK": "Low stock",
      "OVERSTOCK": "Overstocked",
      "EXPIRED": "Expired",
      "EXPIRING": "Expiring soon",
      "PO_OVERDUE": "Delivery overdue",
      "PO_APPROVAL": "Order awaits approval",
      "PR_PENDING": "Request awaits approval",
      "MAINTENANCE_OVERDUE": "Maintenance overdue",
      "MAINTENANCE_DUE": "Maintenance due",
      "WARRANTY_EXPIRING": "Warranty ending",
      "ASSET_OUT_OF_SERVICE": "Equipment not in service",
      "stockDetail": "Usable {{usable}} · reorder at {{reorder}} · on order {{onOrder}}",
      "overDetail": "Usable {{usable}} · maximum {{max}}",
      "lotDetail": "Lot {{lot}} · {{store}} · {{quantity}} · {{date}} · {{value}}",
      "poOverdueDetail": "{{supplier}} · expected {{date}} ({{count}} days late)",
      "prDetail": "By {{by}} · {{priority}}"
    },
    "barcode": "Barcode",
    "grnNumber": "Goods received note",
    "margin": "margin {{value}}%",
    "noPictures": "No pictures. Add one or more photos of the product.",
    "notForSale": "Not for sale",
    "pictures": "Pictures and selling price",
    "salePrice": "Selling price",
    "salePriceDrugHint": "Same price is used for prescriptions and counter sales",
    "salePriceHint": "Price at the pharmacy counter",
    "sellable": "Sold at the counter",
    "docs": {
      "availableNow": "Available now",
      "cancelConfirm": "The document will be cancelled. Stock does not change.",
      "cancelTitle": "Cancel document",
      "cancelled": "Document cancelled",
      "checkNote": "Checker note",
      "checkedBy": "Checked by",
      "destination": "To",
      "fefo": "Earliest expiry first",
      "lineCount": "{{count}} lines",
      "newRequisition": "New requisition",
      "newStockIn": "New stock in",
      "newWriteOff": "Write-off / return",
      "none": "No documents",
      "nothingToCheck": "Nothing waiting for your check",
      "number": "Document",
      "pendingCheck": "Waiting for check",
      "pickItem": "Choose the item to put into stock",
      "pickLotHint": "Write-offs and returns come out of one lot. Choose the item, then use \"Remove\" on the lot.",
      "post": "Check and post",
      "postConfirm": "Stock changes now. Check quantities, lots and expiry dates against the goods.",
      "postTitle": "Post {{number}}",
      "posted": "{{number}} posted; stock updated",
      "receiptDocuments": "Receipts and their check",
      "receiptHint": "The receipt waits for a second person to check the goods and post it to stock.",
      "receiveFromPo": "Receive from purchase order",
      "receivedBy": "Received by",
      "reference": "Reference",
      "reject": "Reject",
      "rejectReason": "Why is it rejected?",
      "rejected": "Document rejected",
      "rejectedBecause": "Rejected: {{note}}",
      "shortNow": "There is not enough stock now for some lines; posting will fail.",
      "storeKeeper": "Store keeper",
      "submitForCheck": "Submit for checking",
      "submitRequisition": "Send requisition",
      "submitted": "{{number}} sent for checking",
      "type": "Type",
      "value": "Value",
      "waitingForChecker": "Waiting for a second person (checker) to post it to stock.",
      "inHint": "Stock in: goods received from purchase orders, opening balances and count corrections. Each document is checked and posted by a second person.",
      "outHint": "Stock out: department requisitions, write-offs, corrections and returns to suppliers. Stock leaves only when a second person posts the document.",
      "transferHint": "Transfers move stock between stores, keeping lot and expiry. Posted by a second person.",
      "checkHint": "Documents prepared by others, waiting for you to check against the goods and post — or reject."
    }
  },
  "gallery": {
    "add": "Add pictures",
    "main": "Main",
    "makeMain": "Make main picture",
    "next": "Next",
    "previous": "Previous",
    "none": "No pictures yet",
    "open": "Open picture"
  },
  "inpatient": {
    "title": "Inpatient care",
    "subtitle": "Admission, bed transfers and discharge, with bed charges by the day",
    "addBed": "Add bed",
    "addRoom": "Add room",
    "admissionNumber": "Admission",
    "admissionType": "Admission type",
    "admit": "Admit",
    "admitPatient": "Admit a patient",
    "admitted": "Admitted: {{number}}",
    "admittedAt": "Admitted",
    "admittingDiagnosis": "Admitting diagnosis",
    "allWards": "All wards",
    "attending": "Attending doctor",
    "attendingDefault": "Not set",
    "bed": "Bed",
    "bedCharges": "Bed charges",
    "bedChargesSoFar": "Bed charges so far",
    "bedDayRule": "Bed days are counted per night (midnight) at the rate of the bed; a same-day stay counts as one day.",
    "bedNumber": "Bed number",
    "bedStays": "Beds used",
    "bedType": "Bed type",
    "beds": "Beds",
    "billAfterDischarge": "Bed days are billed after discharge",
    "billed": "Billed",
    "by": "by {{name}}",
    "cancelAdmission": "Cancel admission",
    "cancelHint": "Only for an admission made by mistake. The bed is freed and nothing is charged.",
    "cancelled": "Admission cancelled",
    "cancelledBecause": "Cancelled: {{reason}}",
    "capacity": "Capacity",
    "clinical": "Clinical",
    "createBill": "Create bill",
    "dailyRate": "Rate per day",
    "dailyRateHint": "Charged per night for each bed in this room",
    "day": "day",
    "dayN": "day {{count}}",
    "discharge": "Discharge",
    "dischargeAnyway": "Discharge anyway",
    "dischargeDiagnosis": "Final diagnosis",
    "dischargeHint": "The bed goes to cleaning and the bed days become billable.",
    "dischargeMedications": "Medicines to take home",
    "dischargeSummary": "Discharge summary",
    "dischargeTitle": "Discharge {{name}}",
    "dischargeType": "Discharged to",
    "discharged": "Patient discharged",
    "dischargedAt": "Discharged",
    "editRoom": "Edit room",
    "editWard": "Edit ward",
    "expectedDischarge": "Expected discharge",
    "expectedShort": "expected out {{date}}",
    "floor": "floor {{floor}}",
    "floorLabel": "Floor",
    "followUpDate": "Follow-up date",
    "followUpInstructions": "Follow-up instructions",
    "from": "From",
    "lengthOfStay": "Length of stay",
    "markClean": "Clean – ready",
    "moveReason": "Reason",
    "newBed": "New bed",
    "newWard": "New ward",
    "nights": "{{count}} nights",
    "nightsHeader": "Nights",
    "noAdmissions": "No admissions",
    "noFreeBeds": "No free beds",
    "noRooms": "No rooms yet",
    "noWards": "No wards yet. Set up wards, rooms and beds first.",
    "notBilledYet": "Not billed yet",
    "now": "now",
    "occupancy": "Bed occupancy",
    "occupiedOf": "{{occupied}} of {{total}} beds",
    "openChart": "Open chart",
    "patient": "Patient",
    "patientOrRelative": "Patient or relative",
    "pendingWork": "Unfinished work for this stay",
    "pending": {
      "serviceOrders": "{{count}} special services not done",
      "labOrders": "{{count}} lab orders open",
      "prescriptions": "{{count}} prescriptions not dispensed",
      "draftNotes": "{{count}} unsigned notes"
    },
    "printNote": "Keep this summary and bring it to your follow-up visit.",
    "reason": "Reason for admission",
    "release": "Make free",
    "room": "Room",
    "roomN": "Room {{room}}",
    "roomType": "Room type",
    "searchAdmissions": "Name, HN or admission number",
    "to": "To",
    "transfer": "Move",
    "transferBed": "Move to another bed",
    "transferHint": "Now in {{bed}}. The old bed goes to cleaning.",
    "transferred": "Moved to {{bed}}",
    "visit": "Visit",
    "ward": "Ward",
    "wardType": "Ward type",
    "searchBeds": "Patient, HN, room or bed",
    "admittedToday": "Admitted today",
    "dueOutToday": "Due out today",
    "overdueOut": "Overdue since {{date}}",
    "noBedsMatch": "No beds match the filter",
    "wardOccupied": "{{occupied}} of {{total}} beds in use",
    "admittedAtField": "Admission date and time",
    "admittedAtHint": "Defaults to now; set it back for a late entry (up to 30 days)",
    "dischargedAtField": "Discharge date and time",
    "dischargedAtHint": "Defaults to now; not before admission ({{at}})",
    "admittedShort": "Admitted {{at}}"
  },
  "services": {
    "title": "Special services",
    "subtitle": "X-ray, CT, ultrasound, ECG, endoscopy, physiotherapy and procedures",
    "allCategories": "All kinds",
    "billedWithVisit": "Billed with the visit",
    "cancelItem": "Cancel {{name}}",
    "cancelOrder": "Cancel order",
    "category": "Kind",
    "clinicalInfo": "Clinical information",
    "complete": "Done",
    "duration": "Duration",
    "durationMinutes": "Duration (minutes)",
    "editReport": "Edit report",
    "editService": "Edit service",
    "findings": "Findings",
    "impression": "Conclusion",
    "inpatient": "Inpatient",
    "itemCancelled": "Service cancelled",
    "markDone": "Complete {{name}}",
    "minutes": "{{count}} min",
    "newService": "New service",
    "noImages": "No images",
    "noOrders": "No special service orders",
    "noReport": "No written report",
    "open": "To do",
    "order": "Order special service",
    "orderCancelled": "Order cancelled",
    "orderFor": "Special services for {{name}}",
    "orderNumber": "Order",
    "ordered": "Ordered: {{number}}",
    "orderedAt": "Ordered",
    "orderedBy": "Ordered by",
    "performedBy": "done by {{name}} {{at}}",
    "preparation": "Patient preparation",
    "preparationHint": "Shown when the service is ordered, e.g. fasting",
    "prepareNote": "Preparation: {{text}}",
    "printReport": "Print report",
    "priority": "Priority",
    "recommendation": "Recommendation",
    "report": "Report",
    "reportHint": "After you submit, a different person verifies the report before it reaches the doctor as final.",
    "reportTitle": "Investigation report",
    "reportVerified": "Report, verified by a second person",
    "reported": "Report submitted for verification",
    "done": "Service completed",
    "reportedBy": "reported by {{name}} {{at}}",
    "reporter": "Reported by",
    "requiresReport": "A written report is needed (verified by a second person)",
    "searchCatalog": "Find a service",
    "searchOrders": "Name, HN or order number",
    "service": "Service",
    "services": "Services",
    "start": "Start",
    "started": "Started",
    "submitReport": "Submit report",
    "verified": "Result verified",
    "verifiedBy": "verified by {{name}} {{at}}",
    "verifier": "Verified by",
    "verify": "Verify",
    "waitingMin": "waiting {{count}} min",
    "waitingVerify": "Waiting for another person to verify your report.",
    "writeReport": "Report: {{name}}",
    "writeReportShort": "Write report"
  },
  "pos": {
    "title": "Pharmacy counter",
    "subtitle": "Sell drugs, medicines, supplies and medical devices",
    "alreadyReturned": "Returned",
    "cart": "Basket",
    "cartEmpty": "Tap a product to add it",
    "cashReceived": "Cash received",
    "cashier": "Cashier",
    "change": "Change",
    "charge": "Take payment {{total}}",
    "controlledNeedsPatient": "Controlled items can only be sold to a registered patient",
    "customer": "Customer",
    "customerName": "Customer name",
    "giveChange": "Give change: {{value}}",
    "inStock": "{{qty}} in stock",
    "netTotal": "{{count}} sales · net {{value}}",
    "nextCustomer": "Next customer",
    "noCashRight": "You may not take cash. Choose another payment method.",
    "noProducts": "No products for sale in this store",
    "noReturns": "No returns",
    "noSales": "No sales in this period",
    "openDrawerFirst": "Open your cash drawer to take cash",
    "patientOptional": "Patient (optional)",
    "purchases": "Purchases",
    "receipt": "Receipt",
    "recordReturn": "Return items",
    "refundMethod": "Refund by",
    "refunded": "Refunded",
    "returnHint": "Returned items go back to the lot they were sold from.",
    "returnQty": "Return",
    "returnTitle": "Return from {{number}}",
    "returned": "Return recorded; stock is back on the shelf",
    "returns": "Returns",
    "saleDiscount": "Discount on the whole sale",
    "saleDone": "Sale {{number}} done",
    "saleNumber": "Sale",
    "salesTitle": "Counter sales",
    "searchOrScan": "Search or scan a barcode",
    "searchSales": "Sale number, customer, phone or HN",
    "sold": "Sold",
    "soldAt": "Sold",
    "supervisorHint": "Returns and voids are done by a supervisor (another person).",
    "suppliesDevices": "Supplies & devices",
    "void": "Void sale",
    "voidHint": "Everything goes back to stock and the sale no longer counts in the cash drawer. Only while the drawer is still open.",
    "voided": "Sale voided",
    "voidedBecause": "Voided by {{name}}: {{reason}}",
    "outlet": "POS outlet",
    "noOutlet": "There is no POS outlet in use yet.",
    "catalog": {
      "title": "Medical POS catalog",
      "subtitle": "What the counter sells and at what price. Products come from the warehouse items.",
      "tab": "Catalog",
      "search": "Name, code, barcode or category",
      "addFromWarehouse": "Add from warehouse",
      "addHint": "Choose warehouse items to sell at the POS. They start at the suggested sale price; change the price afterwards if needed.",
      "allPublished": "All warehouse items are already in the POS catalog.",
      "publishCount": "Add {{count}} to the POS",
      "published": "{{count}} products added to the POS",
      "empty": "No products in the POS catalog",
      "product": "Product",
      "price": "POS price",
      "posStock": "POS stock",
      "warehouseStock": "Warehouse",
      "levels": "Refill at → up to",
      "hide": "Hide from the POS",
      "show": "Show at the POS",
      "editTitle": "POS product: {{name}}",
      "warehouseItem": "Warehouse item",
      "displayName": "Name at the POS",
      "displayNameHint": "Empty = the warehouse name",
      "suggested": "Suggested: {{price}}",
      "sortOrder": "Order on screen",
      "minLevel": "Refill when at or below",
      "minLevelHint": "Counting what is on its way",
      "parLevel": "Refill up to",
      "parLevelHint": "0 = no automatic suggestion",
      "parBelowMin": "Must not be below the refill point",
      "posPicture": "POS picture",
      "useWarehousePicture": "Use the warehouse picture",
      "publishedHint": "Shown and sold at the POS"
    },
    "outlets": {
      "title": "Outlets",
      "add": "New outlet",
      "edit": "Edit outlet",
      "empty": "No outlets yet",
      "hint": "Each outlet keeps its own stock. Stock reaches it only when the warehouse sends a refill and the outlet confirms receipt.",
      "codeHint": "Short code, e.g. POS2",
      "inUse": "In use",
      "products": "Products in stock",
      "incoming": "On its way"
    },
    "stock": {
      "title": "POS stock & refills",
      "subtitle": "Stock at the outlet, what is on its way, and refill requests to the warehouse",
      "products": "Products",
      "inTransit": "On its way",
      "onHand": "At POS",
      "nextExpiry": "Next expiry",
      "expired": "Expired",
      "empty": "Nothing to show"
    },
    "refill": {
      "request": "Request refill",
      "requestHint": "Pre-filled with products at or below their refill point, up to the target level. Change the quantities as needed.",
      "fromStore": "From warehouse store",
      "nothingLow": "Nothing is below its refill point. Add products below if needed.",
      "quantity": "Quantity",
      "addProduct": "Add a product",
      "saveDraft": "Save as draft",
      "send": "Send to warehouse",
      "created": "Refill request {{number}} created",
      "submitted": "Sent to the warehouse",
      "listTitle": "Refill requests",
      "inboxTitle": "Refill requests from the Medical POS",
      "open": "Open",
      "empty": "No refill requests",
      "number": "Request",
      "route": "From → to",
      "lines": "Products",
      "requestedBy": "Requested by",
      "preparedBy": "Prepared by (warehouse)",
      "sentAt": "Sent",
      "receivedBy": "Received by",
      "transfer": "Warehouse transfer",
      "requested": "Requested",
      "inStore": "In {{store}}",
      "sent": "Sent",
      "received": "Received",
      "short": "Short",
      "toSend": "To send",
      "prepare": "Prepare transfer",
      "prepareTitle": "Prepare refill {{number}}",
      "prepareHint": "The POS is waiting for these products. Prepare the transfer; a second warehouse person checks and sends it.",
      "prepareDialogHint": "Quantities start at what was asked for, limited to what the store has. Products with 0 are not sent.",
      "prepared": "Transfer {{doc}} prepared — waiting for the checker to send it",
      "preparingHint": "Prepared by the warehouse. A second warehouse person checks and sends it from Inventory → To check:",
      "waitingWarehouse": "Waiting for the warehouse to prepare it.",
      "sendHint": "Posting this transfer takes the stock out of the warehouse; it reaches the POS outlet when the POS confirms receipt. Refill",
      "inTransitHint": "On its way to the POS. The POS counts what arrived and confirms receipt. Refill",
      "fromRequest": "Prepared for POS refill",
      "receive": "Receive",
      "receiveTitle": "Receive refill {{number}}",
      "receiveHint": "The goods are on their way. Count what arrived and confirm receipt; only then can they be sold.",
      "receiveDialogHint": "Enter what actually arrived. Anything missing is recorded as short and needs a note.",
      "receiveNote": "Note (why something is short)",
      "confirmReceipt": "Confirm receipt",
      "receivedOk": "Received — the products can now be sold",
      "receivedShort": "Received with a shortage: {{note}}",
      "shortValue": "Short value: {{value}}",
      "moreThanSent": "More than was sent",
      "moreThanStore": "More than the store has",
      "reject": "Reject",
      "rejectTitle": "Reject refill {{number}}",
      "rejectReason": "Reason",
      "rejected": "Refill request rejected",
      "rejectedBecause": "Rejected by the warehouse: {{reason}}",
      "cancelTitle": "Cancel refill {{number}}",
      "cancelHint": "The warehouse will not prepare this request."
    }
  },
  "finance": {
    "title": "Finance",
    "subtitle": "Prices and fees, cash drawers, expenses and results",
    "tab": {
      "dashboard": "Overview",
      "prices": "Prices & fees",
      "sessions": "Cash drawers",
      "expenses": "Expenses",
      "history": "Price changes"
    },
    "allCategories": "All categories",
    "amount": "Amount",
    "approveExpense": "Approve {{number}}",
    "approvedTotal": "Approved: {{value}}",
    "balanced": "The count matches",
    "byMethod": "Payments by method",
    "cashExpenseHint": "Cash paid from the drawer counts in your open cash drawer.",
    "cashExpenses": "Cash expenses paid",
    "cashPayments": "Cash bill payments",
    "cashRefunds": "Cash refunds",
    "cashSales": "Cash counter sales",
    "changePrice": "Change price",
    "changePriceOf": "Price of {{name}}",
    "changeReason": "Reason for the change",
    "changedAt": "Changed",
    "changedBy": "Changed by",
    "closeDrawer": "Close cash drawer {{number}}",
    "closeDrawerShort": "Close drawer",
    "closeNote": "Note on the count",
    "closed": "Closed",
    "collected": "Collected",
    "cost": "Cost",
    "costOfGoods": "Drugs & supplies used",
    "countedCash": "Counted cash",
    "counterSales": "Counter sales",
    "currentPrice": "now {{value}}",
    "dailyCash": "Money in and out by day",
    "date": "Date",
    "decidedBy": "Approved / rejected by",
    "discountReason": "Reason for the discount",
    "discountType": "Discount by",
    "discountable": "Discount allowed",
    "discountableHint": "Discounts may be given on this fee",
    "discounts": "Discounts given",
    "drawerOpenShort": "Drawer {{number}} · {{cash}}",
    "drawers": "Open cash drawers",
    "editFee": "Edit fee",
    "expectedCash": "Expected cash",
    "expenseApprovalHint": "A different person approves the expense before it counts.",
    "expenseNumber": "Expense",
    "expenseOnlyHint": "You can record expenses; the finance team approves them.",
    "expenseRecorded": "Expense {{number}} sent for approval",
    "expenses": "Expenses",
    "expensesByCategory": "Expenses by category",
    "grossProfit": "gross profit {{value}}",
    "item": "Item",
    "lastChange": "Last change",
    "margin": "Margin",
    "myDrawer": "My cash drawer",
    "netProfit": "Net profit",
    "newExpense": "Record expense",
    "newFee": "New fee",
    "newPrice": "New price",
    "noChanges": "No price changes",
    "noExpenses": "No expenses",
    "noOpenDrawer": "You have no open cash drawer.",
    "noSessions": "No cash drawers",
    "oldPrice": "Old price",
    "openDrawer": "Open cash drawer",
    "openDrawerHint": "Count the change in the drawer and enter it as the opening float.",
    "opened": "Opened",
    "openedAt": "opened {{at}}",
    "openingFloat": "Opening float",
    "otherVerifies": "A different person must count and verify this drawer.",
    "outstanding": "Unpaid bills",
    "payee": "Paid to",
    "pendingApproval": "{{count}} waiting for approval",
    "percent": "Percent",
    "percentValue": "Percent (%)",
    "price": "Price",
    "priceChangeHint": "New bills use the new price; existing bills keep theirs. Every change is kept in the price history.",
    "priceSaved": "Price changed",
    "pricesHint": "Every fee, drug, lab test, special service, bed rate and item for sale has a price here. Discounts by amount or percent are given on the bill or at the counter.",
    "recordedBy": "Recorded by",
    "rejectExpense": "Reject {{number}}",
    "revenue": "Revenue",
    "revenueBySource": "Revenue by source",
    "revenueSplit": "bills {{invoices}} · counter {{sales}}",
    "searchPrices": "Find by name or code",
    "session": "Cash drawer",
    "sessionClosed": "Drawer {{number}} closed; waiting to be verified",
    "sessionOpened": "Drawer {{number}} opened",
    "sessionTitle": "Drawer {{number}} · {{name}}",
    "sessionVerified": "Drawer verified",
    "submitExpense": "Send for approval",
    "taxRate": "Tax rate (%)",
    "toVerify": "{{count}} closed, to verify",
    "type": "Type",
    "variance": "Difference",
    "varianceIs": "Difference {{value}}; please explain it",
    "verifiedBy": "Verified by",
    "verifyCount": "Verify the count"
  },
  "diseases": {
    "title": "Disease catalog",
    "subtitle": "ICD-10 codes, names and disease types used for diagnoses and reports",
    "tabDiseases": "Diseases",
    "tabTypes": "Disease types",
    "searchPlaceholder": "Search by ICD-10 code or name…",
    "type": "Disease type",
    "allTypes": "All types",
    "notifiableOnly": "Notifiable only",
    "newDisease": "New disease",
    "empty": "No diseases match",
    "code": "ICD-10 code",
    "codeHint": "e.g. A90 or J06.9; kept in capitals",
    "name": "Name",
    "nameLo": "Name (Lao)",
    "nameEn": "Name (English)",
    "notifiable": "Notifiable",
    "notifiableShort": "Report",
    "notifiableHint": "Notifiable disease: cases must be reported to the health authority",
    "notifiableWarning": "{{name}} is a notifiable disease. Remember to report the case.",
    "noType": "— No type —",
    "activeHint": "In use (shown when picking a diagnosis)",
    "activeTypeHint": "In use",
    "deleteDisease": "Delete disease",
    "deleteDiseaseMessage": "Remove {{code}} from the catalog? Diagnoses already recorded keep their code and text.",
    "deleted": "Deleted",
    "newType": "New disease type",
    "noTypes": "No disease types yet",
    "diseaseCount": "Diseases",
    "sortOrder": "Display order",
    "color": "Colour",
    "customColor": "Custom colour",
    "preview": "Preview",
    "typeInUseHint": "{{count}} diseases use this type, so it cannot be deleted. Move them or turn the type off.",
    "deleteType": "Delete disease type",
    "deleteTypeMessage": "Delete the disease type {{code}}?",
    "pickFromCatalog": "Find in the disease catalog"
  },
  "national": {
    "title": "National reporting",
    "subtitle": "KPI results, approved report snapshots and DHIS2 submissions",
    "tab": {
      "dashboard": "KPI dashboard",
      "snapshots": "Report snapshots",
      "catalog": "KPI catalogue",
      "batches": "DHIS2 submissions",
      "mappings": "DHIS2 mappings",
      "connections": "DHIS2 connections"
    },
    "period": "Period",
    "calculate": "Calculate KPIs",
    "calculated": "KPIs calculated",
    "lastRun": "Last calculated {{at}} by {{by}}",
    "notCalculatedYet": "No KPI has been calculated for this period yet. Choose Calculate KPIs.",
    "notCalculatedReadOnly": "No KPI has been calculated for this period yet.",
    "notCalculated": "Not calculated",
    "noKpis": "No KPIs",
    "target": "Target",
    "warning": "Warning level",
    "warningAt": "Warning at {{value}}",
    "numeratorDenominator": "Numerator / denominator",
    "formulaVersion": "Formula version {{n}}",
    "trend": "Last six periods",
    "breakdown": "Breakdown",
    "report": "Report",
    "allReports": "All reports",
    "allStatuses": "All statuses",
    "allTypes": "All types",
    "generateSnapshot": "Generate snapshot",
    "generate": "Generate",
    "noSnapshots": "No report snapshots yet",
    "version": "Version",
    "checks": "Checks",
    "clean": "No issues",
    "errors": "Errors: {{count}}",
    "warnings": "Warnings: {{count}}",
    "generated": "Generated",
    "approvedBy": "Approved by",
    "includesKpis": "This report includes:",
    "generateHint": "The KPIs are calculated again and frozen into a new numbered version. Someone other than you must approve it before it can be sent.",
    "snapshotGenerated": "Snapshot generated",
    "snapshotValidated": "Snapshot validated",
    "snapshotApproved": "Snapshot approved",
    "snapshotInvalidated": "Snapshot invalidated",
    "invalidate": "Invalidate",
    "validate": "Validate",
    "approve": "Approve",
    "prepareDhis2": "Send to DHIS2…",
    "cannotApproveOwn": "You cannot approve your own work",
    "generatedBy": "Generated by {{by}} on {{at}}",
    "approvedByAt": "approved by {{by}} on {{at}}",
    "approvedByName": "Approved by {{by}}",
    "createdByAt": "Created by {{by}} on {{at}}",
    "needsOtherApprover": "Waiting for approval by another person (segregation of duties).",
    "invalidatedBecause": "Invalidated: {{reason}}",
    "supersededHint": "A newer approved version replaces this snapshot.",
    "values": "Values",
    "kpi": "KPI",
    "value": "Value",
    "formula": "Formula",
    "quality": "Data quality",
    "dhis2Batches": "DHIS2 submissions",
    "invalidateMessage": "An invalidated snapshot can no longer be sent; batches not yet sent are cancelled. Give the reason.",
    "reason": "Reason",
    "connection": "Connection",
    "createBatch": "Create batch",
    "noConnections": "No DHIS2 connection is set up yet",
    "createBatchHint": "Values are mapped to DHIS2 data elements and checked. The batch is sent only after another person approves it.",
    "batchCreated": "Batch created",
    "noIssues": "No issues found",
    "issue": {
      "INSUFFICIENT_DATA": "Too little data",
      "NO_FORMULA": "No approved formula",
      "DIMENSION_TOTAL_MISMATCH": "Breakdown differs",
      "PERIOD_OPEN": "Period not ended",
      "NO_ORG_UNIT_MAPPING": "Org unit not mapped",
      "NO_DATA_SET_MAPPING": "Data set not mapped",
      "NO_DATA_ELEMENT_MAPPING": "Data element not mapped",
      "NO_VALUE": "No value",
      "NOT_SENT_QUALITY": "Not sent (quality)",
      "NO_CATEGORY_MAPPING": "Category not mapped",
      "NOTHING_TO_SEND": "Nothing to send"
    },
    "catalogHint": "Formulas are built-in calculators. A new formula version is used only after someone other than its author approves it.",
    "newKpi": "New KPI",
    "category": "Category",
    "unit": "Unit",
    "noFormula": "No approved formula",
    "draftVersions": "Draft versions: {{count}}",
    "nameEn": "Name (English)",
    "nameLo": "Name (Lao)",
    "direction": "Direction",
    "owner": "Owner",
    "unitFixed": "The unit cannot change after creation",
    "newKpiHint": "After saving, add a formula version and have it approved before the KPI can be calculated.",
    "newTarget": "New target",
    "newFormulaVersion": "New formula version",
    "targetNeedsDirection": "Set whether higher or lower is better first",
    "ownedBy": "Owner: {{owner}}",
    "formulaVersions": "Formula versions",
    "definition": "Definition",
    "numerator": "Numerator",
    "denominator": "Denominator",
    "effective": "Effective",
    "minDenominator": "Minimum denominator",
    "targets": "Targets",
    "infoNoTarget": "Information-only KPIs have no target",
    "noTargets": "No targets yet",
    "formulaApproved": "Formula version approved",
    "formulaDrafted": "Draft formula version saved",
    "calculator": "Calculator",
    "parameters": "Parameters (JSON)",
    "parametersInvalid": "Enter a JSON object, e.g. {\"windowDays\": 30}",
    "effectiveFrom": "Effective from",
    "changeRationale": "Reason for the change",
    "saveDraft": "Save as draft",
    "formulaApprovalHint": "The new version starts on its effective date once approved; the previous version ends the day before.",
    "lowerBetterHint": "Lower is better: values at or below the target are achieved, up to the warning level they are a warning.",
    "higherBetterHint": "Higher is better: values at or above the target are achieved, down to the warning level they are a warning.",
    "batchesHint": "Batches are sent in the background and retried automatically when DHIS2 is unavailable.",
    "noBatches": "No DHIS2 submissions yet",
    "batch": "Batch",
    "batchApproved": "Batch approved",
    "batchQueued": "Batch queued for sending",
    "batchReconciled": "Batch reconciled with DHIS2",
    "batchCancelled": "Batch cancelled",
    "cancelBatch": "Cancel batch",
    "send": "Send to DHIS2",
    "retry": "Send again",
    "reconcile": "Reconcile",
    "dataSetOrgUnit": "data set {{ds}} · org unit {{ou}}",
    "batchHasErrors": "This batch has errors and cannot be sent. Fix the mappings, cancel it and create a new batch.",
    "reconcileHint": "DHIS2 did not answer in time. Reconcile to read the values back before sending again.",
    "nextAttempt": "Next automatic attempt {{at}}",
    "dataValues": "Data values",
    "noValues": "No values",
    "dataElement": "Data element",
    "categoryOptionCombo": "Category option combo",
    "importResults": "Import results",
    "counts": "Counts",
    "countsLine": "{{imported}} imported, {{updated}} updated, {{ignored}} ignored of {{total}}",
    "conflicts": "Conflicts",
    "activity": "Activity",
    "showPayload": "Show payload",
    "hidePayload": "Hide payload",
    "mappingType": "Mapping type",
    "newMapping": "New mapping",
    "noMappings": "No mappings",
    "local": "HMS object",
    "onlyFor": "Only for {{report}}",
    "notInMetadata": "Not in metadata",
    "transform": "Value transform",
    "retire": "Retire",
    "mappingApproved": "Mapping approved",
    "mappingRetired": "Mapping retired",
    "mappingDrafted": "Draft mapping saved",
    "dhis2Object": "DHIS2 object",
    "refreshMetadataFirst": "Refresh the DHIS2 metadata first",
    "cocHint": "Used when the value is sent as a total",
    "defaultCoc": "default",
    "scopeReport": "Only for report",
    "scopeReportHint": "Use when the same KPI goes to a different data element in another report",
    "anyReport": "Any report",
    "mappingApprovalHint": "A mapping is used only after someone other than its author approves it.",
    "connectionsHint": "Credentials are never stored in HMS: give the name of a server environment variable that holds them.",
    "newConnection": "New connection",
    "connectionOk": "Connected to DHIS2",
    "connectionFailed": "Could not connect to DHIS2",
    "metadataRefreshed": "Metadata refreshed",
    "auth": "Authentication",
    "secretSet": "set",
    "secretMissing": "not set on the server",
    "lastHealth": "Checked {{at}}",
    "lastMetadata": "metadata {{at}}",
    "approvedMappings": "Approved mappings: {{count}}",
    "draftMappings": "Draft mappings: {{count}}",
    "testConnection": "Test connection",
    "refreshMetadata": "Refresh metadata",
    "baseUrl": "Base URL",
    "baseUrlHint": "e.g. https://dhis2.example.gov.la (no user name or password in the link)",
    "environment": "Environment",
    "apiVersion": "API version",
    "authPat": "Personal access token",
    "authBasic": "User name and password",
    "secretReference": "Environment variable",
    "secretHint": "Set the variable on the server: a token for personal access token, or username:password for basic authentication.",
    "enabled": "Enabled",
    "urlError": {
      "invalid": "Enter an http(s) link without user name or password",
      "httpsRequired": "Production needs https"
    },
    "periodOpenText": "The period has not ended yet; values may still change.",
    "msg": {
      "minRecords": "Only {{count}} record(s); at least {{min}} needed",
      "noData": "No data for this period",
      "noFormula": "No approved formula version for this period",
      "stockPoint": "Stock position at the time of calculation",
      "medianNote": "Median of tickets with both times recorded",
      "breakdownGap": "Breakdown adds up to {{sum}} of {{total}} (unknown sex or date of birth)"
    }
  },
  "tenants": {
    "title": "Tenants & hospitals",
    "subtitle": "Organizations using this system and their hospitals. Each hospital keeps its own patients, staff, stock and money.",
    "newTenant": "New tenant",
    "none": "No tenants yet",
    "suspend": "Suspend",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "addHospital": "Add hospital",
    "noHospitals": "No hospitals yet",
    "hospital": "Hospital",
    "users": "Users",
    "patients": "Patients",
    "created": "Created",
    "signInLink": "Sign-in link",
    "linkCopied": "Sign-in link copied",
    "openHospital": "Open",
    "current": "Signed in here",
    "sharedCatalogNote": "Medicines, lab tests, fees and special services are a shared national catalog, including their prices. Separate prices per tenant are planned with the tenancy hardening phase.",
    "codeHint": "Short code in capitals, e.g. MOH or OPI",
    "type": "Type",
    "nameLo": "Name (Lao)",
    "nameEn": "Name (English)",
    "hospitalCodeHint": "Unique code, also used in the sign-in link",
    "startingData": "Starting data",
    "startingDataHint": "Every new hospital gets the disease catalog, the KPI catalogue and the national reports. Appointment types and, if you choose, departments are copied from another hospital.",
    "copyFrom": "Copy settings from",
    "noTemplate": "Do not copy",
    "copyDepartments": "Also copy departments",
    "firstAdmin": "First administrator",
    "adminNew": "New account",
    "adminExisting": "Existing user",
    "adminLater": "Later",
    "passwordHint": "At least 8 characters with upper- and lower-case letters and a number; the administrator changes it after signing in",
    "grantMe": "Give me access to this hospital (to set it up)",
    "createHospital": "Create hospital",
    "hospitalCreated": "Hospital created and set up"
  },
  "referrals": {
    "title": "Referrals",
    "subtitle": "Patients we send to other facilities and patients referred to us, with their replies and outcomes",
    "new": "New referral",
    "refer": "Refer",
    "none": "No referrals",
    "number": "Referral no.",
    "direction": "Direction",
    "patient": "Patient",
    "facility": "Facility",
    "reason": "Reason for referral",
    "priority": "Priority",
    "open": "Open (not finished)",
    "search": "Search by number, patient or facility…",
    "outLong": "We refer the patient out",
    "inLong": "Referred to us",
    "toFacility": "Refer to",
    "fromFacility": "Referred from",
    "facilityContact": "Facility contact",
    "specialty": "Specialty / service",
    "diagnosis": "Diagnosis",
    "clinicalSummary": "Clinical summary",
    "clinicalSummaryHint": "History, findings, tests and treatment so far",
    "transport": "Transport",
    "created": "Referral created",
    "sent": "Referral marked as sent",
    "printLetter": "Print referral letter",
    "printSummary": "Print summary",
    "logContact": "Record a contact",
    "markSent": "Mark as sent",
    "markUnreachable": "Could not reach",
    "decline": "Declined",
    "accept": "Accepted",
    "complete": "Record outcome",
    "byOn": "By {{by}} on {{at}}",
    "encounter": "Visit",
    "appointmentAt": "Appointment",
    "contactAttempts": "Contact attempts",
    "response": "Reply",
    "outcome": "Outcome",
    "cancelledBecause": "Cancelled: {{reason}}",
    "history": "History",
    "contactResult": "Result of the contact",
    "step": {
      "accept": "Referral accepted",
      "decline": "Referral declined",
      "unreachable": "Facility could not be reached",
      "complete": "Outcome of the referral",
      "cancel": "Cancel the referral",
      "contact": "Contact with the facility or patient"
    },
    "done": {
      "accept": "Referral accepted",
      "decline": "Referral declined",
      "unreachable": "Marked as not reachable",
      "complete": "Outcome recorded",
      "cancel": "Referral cancelled",
      "contact": "Contact recorded"
    },
    "noteLabel": {
      "accept": "Note (who accepted, instructions)",
      "decline": "Why it was declined",
      "unreachable": "What was tried",
      "complete": "Outcome (diagnosis, treatment, plan)",
      "cancel": "Reason for cancelling",
      "contact": "Note"
    },
    "letterTitle": "REFERRAL LETTER",
    "summaryTitle": "REFERRAL RECEIVED",
    "referringClinician": "Referring clinician",
    "receivingFacility": "Receiving facility",
    "feedbackRequest": "Feedback",
    "feedbackText": "Please send back your findings and treatment plan so that we can continue the patient's care."
  },
  "followUps": {
    "title": "Follow-ups",
    "subtitle": "Planned follow-ups across departments: what is due, overdue and done",
    "new": "New follow-up",
    "plan": "Plan follow-up",
    "none": "No follow-ups",
    "due": "Due",
    "patient": "Patient",
    "reason": "Reason",
    "who": "Department / doctor",
    "outcome": "Outcome",
    "done": "Done",
    "missed": "Missed",
    "reopen": "Reopen",
    "overdueBy": "{{days}} day(s) overdue",
    "inDays": "in {{days}} day(s)",
    "created": "Follow-up planned",
    "priority": "Priority",
    "department": "Department",
    "practitioner": "Doctor",
    "instructions": "Instructions for the patient",
    "instructionsHint": "e.g. come fasting, bring your medicines",
    "filter": {
      "upcoming": "Due within a week",
      "overdue": "Overdue",
      "today": "Due today",
      "week": "Next 7 days"
    },
    "action": {
      "complete": "Follow-up done",
      "missed": "Patient did not come",
      "cancel": "Cancel follow-up"
    },
    "noteLabel": {
      "complete": "Outcome",
      "missed": "Note (optional)",
      "cancel": "Reason for cancelling"
    }
  },
  "duplicates": {
    "title": "Duplicate patients",
    "subtitle": "Records that may belong to the same person. One person asks for a merge; another approves it.",
    "tabSuggestions": "Possible duplicates",
    "tabRequests": "Merge requests",
    "noneFound": "No likely duplicates found",
    "suggestionsHint": "{{count}} possible duplicate pair(s), most likely first",
    "requestPending": "Merge waiting for approval",
    "notDuplicates": "Not the same person",
    "askMerge": "Ask to merge",
    "dismissed": "Pair will not be suggested again",
    "dismissMessage": "These two records belong to different people and will not be suggested again.",
    "dismissReason": "Why (e.g. twins, parent and child)",
    "visits": "{{count}} visit(s)",
    "lastVisit": "last {{date}}",
    "registered": "registered {{date}}",
    "keepThis": "Keep this record",
    "keeping": "Record kept",
    "chooseSurvivor": "Choose the record to keep. Everything from the other record moves to it.",
    "mergeExplain": "{{merge}} will be merged into {{keep}}: visits, bills, results and other records move across, and the merged record can no longer be used.",
    "reasonLabel": "Reason",
    "sendForApproval": "Send for approval",
    "requested": "Merge sent for approval",
    "noRequests": "No merge requests",
    "askedBy": "Asked by {{by}} on {{at}}",
    "decidedBy": "decided by {{by}} on {{at}}",
    "survivor": "Kept",
    "duplicate": "Merged into the kept record",
    "decisionNote": "Decision note",
    "movedRecords": "{{count}} record(s) moved to the kept patient",
    "keptOnDuplicate": "left on the merged record (one per patient): {{list}}",
    "cancelRequest": "Cancel request",
    "reject": "Reject",
    "approveMerge": "Approve merge",
    "mergeNow": "Merge now",
    "approveNote": "Note (optional)",
    "rejectNote": "Why it is rejected",
    "merged": "Records merged",
    "rejected": "Merge rejected",
    "mergedBanner": "This record was merged into another patient record and can no longer be used.",
    "openSurvivor": "Open the kept record",
    "reason": {
      "NAME_DOB": "Same name and birth date",
      "SIMILAR_NAME_DOB": "Similar name, same birth date",
      "PHONE_NAME": "Same phone, similar name",
      "IDENTIFIER": "Same ID number"
    }
  },
  "registry": {
    "sectionNamesEn": "Names in English and nickname",
    "firstNameEn": "First name (English)",
    "lastNameEn": "Last name (English)",
    "nickname": "Nickname",
    "nicknameEn": "Nickname (English)",
    "sectionBackground": "Background",
    "nationality": "Nationality",
    "country": "Citizenship (country)",
    "ethnicity": "Ethnic group",
    "religion": "Religion",
    "firstLanguage": "First language",
    "occupation": "Occupation",
    "educationLevel": "Education level",
    "sectionBirth": "Place of birth",
    "birthCountry": "Country of birth",
    "birthPlace": "Place of birth (other)",
    "birthPlaceHint": "Hospital or place, if not a village",
    "sectionHousehold": "Household",
    "houseNo": "House no.",
    "householdUnit": "Household unit (ໜ່ວຍ)",
    "familyBookNo": "Family book no.",
    "relationshipToHead": "Relationship to the head of household",
    "isHouseholdHead": "Head of the household",
    "sectionParents": "Parents",
    "fatherName": "Father's name",
    "motherName": "Mother's name",
    "parentOccupation": "Occupation",
    "parentPhone": "Phone",
    "parentNationalId": "National ID card",
    "parentWorkplace": "Place of work",
    "sectionHealth": "Health background",
    "hearingIssue": "Hearing problem",
    "speakingIssue": "Speaking problem",
    "visionIssue": "Eye or vision problem",
    "heightCm": "Height (cm)",
    "weightKg": "Weight (kg)",
    "medicalIssues": "Medical issues",
    "seriousIllness": "Serious illness in the past",
    "title": "Registry details",
    "namesEn": "Name in English",
    "heightWeight": "Height and weight",
    "sectionDisability": "Disability",
    "disabilityTypes": "Disability type",
    "disabilityTypesHint": "Choose all that apply; sub-types open under a chosen type. \"Unknown / Not assessed\" cannot be combined with others.",
    "disabilityChooseOne": "choose one",
    "disabilityChooseAny": "choose any that apply"
  },
  "staffKpi": {
    "title": "Work summary",
    "titleFor": "Work summary: {{name}}",
    "subtitle": "What was recorded under this account each month, by area of the system",
    "backToUsers": "Back to users",
    "showAll": "Also show work with no entries",
    "nothing": "Nothing recorded for {{period}}",
    "vsPrevious": "previous period {{value}}",
    "column": "Work summary",
    "open": "View",
    "mine": "My work summary",
    "metric": {
      "PATIENTS_REGISTERED": "Patients registered",
      "APPOINTMENTS_BOOKED": "Appointments booked",
      "QUEUE_CALLED": "Patients called from the queue",
      "ENCOUNTERS_SEEN": "Visits seen (as doctor)",
      "VITALS_RECORDED": "Vital signs recorded",
      "DIAGNOSES_RECORDED": "Diagnoses recorded",
      "NOTES_SIGNED": "Notes signed",
      "LAB_ORDERS": "Lab tests ordered",
      "LAB_RESULTS_ENTERED": "Lab results entered",
      "LAB_RESULTS_VERIFIED": "Lab results verified",
      "SERVICES_REPORTED": "Special service reports",
      "REFERRALS_MADE": "Referrals made",
      "FOLLOW_UPS_DONE": "Follow-ups completed",
      "EYE_EXAMS_SIGNED": "Eye exams signed",
      "VA_MEASURED": "Visual acuity measurements",
      "SURGERIES_PERFORMED": "Operations performed",
      "INJECTIONS_GIVEN": "Injections given",
      "ADMISSIONS": "Admissions",
      "DISCHARGES": "Discharges",
      "PRESCRIPTIONS_WRITTEN": "Prescriptions written",
      "DISPENSED": "Prescriptions dispensed",
      "POS_SALES": "Counter sales",
      "STOCK_DOCUMENTS": "Stock documents",
      "INVOICES_ISSUED": "Bills issued",
      "PAYMENTS_RECEIVED": "Payments received",
      "PAYMENTS_AMOUNT": "Amount received",
      "SYSTEM_ACTIONS": "Actions in the system"
    },
    "team": {
      "title": "Staff KPIs",
      "subtitle": "Work recorded per person each month, compared with monthly targets",
      "leaderboard": "Leaderboard",
      "targets": "Targets",
      "metric": "Measure",
      "role": "Role",
      "anyRole": "All roles",
      "showZero": "Also show staff with no work",
      "rank": "Rank",
      "staff": "Staff",
      "roles": "Roles",
      "department": "Department",
      "thisMonth": "This period",
      "lastMonth": "Previous period",
      "target": "Target",
      "achievement": "Achieved",
      "noTarget": "No target",
      "total": "Team total",
      "counted": "Staff with work",
      "withTarget": "Staff with a target",
      "metTarget": "Met the target",
      "empty": "No work recorded for this measure and month.",
      "supervisionNote": "For supervision and coaching only — staff KPIs are never sent to DHIS2 and must not be used for automatic HR decisions.",
      "addTarget": "Add target",
      "editTarget": "Edit target",
      "appliesTo": "Applies to",
      "forRole": "A role",
      "forPerson": "One person",
      "person": "Person",
      "monthlyTarget": "Monthly target",
      "monthlyTargetMoney": "Monthly target (amount)",
      "targetHint": "Per month. Quarters count ×3, years ×12, days and date ranges are prorated by days. A person's own target replaces their role's target.",
      "targetsHelp": "Targets per role apply to everyone with that role; a target for one person replaces it.",
      "noTargets": "No targets yet.",
      "updated": "Last changed",
      "deleteTarget": "Delete target"
    },
    "dash": {
      "title": "Dashboard",
      "vsLastMonth": "vs previous period",
      "activeStaff": "Staff with work",
      "targetsMet": "Targets met",
      "ofTargets": "{{met}} of {{total}}",
      "byArea": "Work by area over time",
      "attainment": "Targets in this period",
      "met": "Met",
      "close": "Close (70–99%)",
      "behind": "Behind (under 70%)",
      "noTargets": "No targets set yet — add them on the Targets tab.",
      "withoutTarget": "{{value}} staff with work have no target.",
      "top5": "Top 5",
      "byRole": "Work by role in this period",
      "byRoleHint": "People with several roles count under each role.",
      "people": "{{value}} people",
      "workItems": "Work items",
      "heatmap": "Work per person over time",
      "heatmapHint": "Darker = more work items. Click a row for the person's summary."
    },
    "period": {
      "day": "Day",
      "month": "Month",
      "quarter": "Quarter",
      "year": "Year",
      "range": "Date range",
      "from": "From",
      "to": "To",
      "vs": "compared with {{previous}}",
      "prorated": "targets prorated by days"
    },
    "trendTotal": "chart total {{value}}"
  },
  "roles": {
    "title": "Roles & permissions",
    "subtitle": "Each role is a set of permissions. Give roles to people on the Users page.",
    "newRole": "New role",
    "howItWorks": "Changes reach each person within 15 minutes (at their next sign-in or token refresh). Roles are shared by all hospitals; platform permissions stay with the super administrator.",
    "searchRoles": "Search roles…",
    "permissionCount": "{{count}} permissions",
    "pick": "Choose a role",
    "locked": "Locked",
    "builtIn": "Built-in",
    "custom": "Custom",
    "inUse": "Still given to users",
    "name": "Role name",
    "usersLine": "{{here}} user(s) in this hospital · {{total}} in all hospitals",
    "saveDetails": "Save details",
    "lockedHint": "The super administrator always has every permission.",
    "permissions": "Permissions ({{count}})",
    "searchPermissions": "Search permissions…",
    "savePermissions": "Save permissions",
    "platformOnly": "Platform only",
    "deleteRole": "Delete role",
    "deleteMessage": "Delete the role {{name}}? Nobody has it.",
    "create": "Create role",
    "codeHint": "Capitals and _, e.g. EYE_SCREENER",
    "copyFrom": "Copy permissions from",
    "startEmpty": "Start with no permissions",
    "saved": "Permissions saved",
    "deleted": "Role deleted",
    "created": "Role created"
  },
  "permGroup": {
    "appointment": "Appointments",
    "audit": "Audit log",
    "billing": "Billing",
    "careplan": "Care plans",
    "cash": "Cash drawer",
    "dhis2": "DHIS2",
    "diagnosis": "Diagnoses",
    "disease": "Disease catalog",
    "encounter": "Encounters",
    "finance": "Finance",
    "followup": "Follow-ups",
    "i18n": "Languages & wording",
    "inpatient": "Inpatient",
    "inventory": "Inventory",
    "kpi": "KPIs",
    "lab": "Laboratory",
    "location": "Locations",
    "medication": "Medicines",
    "note": "Clinical notes",
    "ophthalmology": "Eye center",
    "organization": "Hospital & departments",
    "pathway": "Treatment cycles",
    "patient": "Patients",
    "payment": "Payments",
    "pharmacy": "Pharmacy",
    "portal": "Patient app",
    "pos": "Medical POS",
    "prescription": "Prescriptions",
    "purchase": "Procurement",
    "queue": "Queue",
    "referral": "Referrals",
    "report": "Reports",
    "role": "Roles",
    "sales": "Counter sales",
    "service": "Special services",
    "tenant": "Tenants",
    "user": "Users",
    "ward": "Wards & beds",
    "reference": "Shared code lists",
    "staffkpi": "Staff KPIs"
  },
  "permAction": {
    "admin": "Administer",
    "approve": "Approve",
    "collect": "Collect",
    "discount": "Give discounts",
    "dispense": "Dispense",
    "enter": "Enter results",
    "global": "All hospitals",
    "manage": "Manage",
    "merge": "Merge records",
    "order": "Order",
    "perform": "Perform",
    "prepare": "Prepare",
    "read": "View",
    "refund": "Refund",
    "request": "Request",
    "sell": "Sell",
    "sensitive": "Sensitive details",
    "session": "Open and close",
    "sign": "Sign",
    "stock": "Stock",
    "submit": "Submit",
    "surgery": "Surgery",
    "verify": "Verify",
    "void": "Void",
    "write": "Create and edit",
    "kiosk": "Run the kiosk",
    "display": "Show displays",
    "triage": "Clinical priority",
    "configure": "Configure"
  },
  "apptDash": {
    "title": "Appointment dashboard",
    "subtitle": "Today's schedule, the month at a glance and follow-ups that need attention",
    "followUpWatch": "Follow-up watch",
    "followUpWatchHint": "Scheduled follow-ups that are late or coming up",
    "followUpRestOfWeek": "Rest of the next 7 days",
    "patients": "{{value}} patients",
    "openFollowUps": "open follow-ups",
    "needsAttention": "Needs attention",
    "noOverdue": "No overdue follow-ups.",
    "otherDepartments": "Other",
    "byDepartment": "Appointments by department",
    "byDepartmentHint": "Share of {{month}} appointments",
    "lastMonth": "Last month",
    "pillHint": "Pills show the change against last month.",
    "scheduled": "Booked",
    "overview": "Appointment overview",
    "overviewHint": "{{month}} totals · schedule for {{date}}",
    "calendar": "Appointment calendar",
    "calendarHint": "Pick a day to see its schedule",
    "more": "+{{value}} more",
    "legend": "Legend",
    "legendHint": "Calendar colours by department",
    "waiting": "Waiting",
    "arrived": "Arrived",
    "patientsBooked": "Patients",
    "beds": "Beds",
    "bedsHint": "Inpatient wards",
    "doctorsOnDuty": "Doctors on duty",
    "activeDoctors": "Active doctors",
    "departmentsOpen": "Departments",
    "upcoming": "Upcoming",
    "next7Days": "Next 7 days",
    "weekdays": {
      "1": "Mon",
      "2": "Tue",
      "3": "Wed",
      "4": "Thu",
      "5": "Fri",
      "6": "Sat",
      "7": "Sun"
    }
  },
  "disabilityTypes": {
    "title": "Disability types",
    "subtitle": "Classification used when registering patients. Shared by all hospitals.",
    "new": "New disability type",
    "deleted": "Disability type deleted",
    "inUseHint": "Patients with this type: {{count}}. It cannot be deleted; untick \"In use\" to hide it from registration.",
    "codeHint": "Capital letters, digits, - or _ (for example PWD11)",
    "sortOrder": "Display order",
    "nameLa": "Name (Lao)",
    "nameEn": "Name (English)",
    "activeLabel": "In use (shown when registering patients)",
    "deleteTitle": "Delete disability type?",
    "deleteMessage": "{{code}} will be removed. No patient has it.",
    "patients": "Patients",
    "parent": "Sub-type of",
    "noParent": "— Main type —",
    "icd11Code": "ICD-11 code",
    "exclusiveLabel": "Cannot be combined with other types (for example Unknown / Not assessed)",
    "singleChoiceLabel": "Only one of its sub-types can be chosen",
    "exclusiveBadge": "Alone only",
    "singleChoiceBadge": "One sub-type"
  },
  "queueServices": {
    "title": "Queue service points",
    "subtitle": "Each service point has its own queue every day. Patients keep one number while they move between them.",
    "add": "Add service point",
    "edit": "Edit {{code}}",
    "prefix": "Number prefix",
    "prefixHint": "Letters or digits, e.g. R gives R-001",
    "nameLocal": "Name (Lao)",
    "nameEn": "Name (English)",
    "departmentHint": "A department's appointments and walk-ins start at its first service point",
    "noDepartment": "No department",
    "counters": "Counters / rooms",
    "countersHint": "Separated by commas, e.g. Room 1, Room 2",
    "sortOrder": "Order",
    "sortOrderHint": "Lower numbers come first",
    "kiosk": "Kiosk",
    "kioskEnabled": "Walk-in patients can choose it at the kiosk"
  }
}
